<!-- <div class="recordList" *ngIf="by_photoListing !== 'true'">
    Showing
    <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize"
    (ngModelChange)="onPageSizeChange($event)">
       <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
     </select>
   results
 </div> -->
<input type="text" value="" class="heightzero" #clipboardInput>
<!-- <button id="EMBED_code" #clipboardButton (click)="copyInputMessage(clipboardInput)">Copy</button> -->
<div class="tabcontainer" *ngIf="domainConfig">

  <div class="podcastSearchBlock" *ngIf="page_id =='podcast'"> 
    <div class="searchSection">
      <!-- <label>
        Publishers
      </label> -->
      <div class="dataField">
        <i class="icon-search"></i>
        <input type="text" class="textBox" placeholder="Find Publisher" [(ngModel)]="selectedPublisherQuery" (keyup)="filterAutoCompleteUp($event ,'publisher')" (keydown)="true"
        (focus)="focusInSuggest('publisher')" (focusout)="focusOut('publisher')">
        <ng-container>
          <div class="autosuggestion block" *ngIf="insidePublisher && filteredPublisherSuggestion && filteredPublisherSuggestion.length > 0">
            <ul>
              <li *ngFor="let publisher of filteredPublisherSuggestion; let i = index">
                <span class="name" (mousedown)="selectPublisher(publisher, false)">{{publisher.name}}</span>
              </li>
            </ul>
          </div>
          <ng-container *ngIf="insidePublisher && (1 > filteredPublisherSuggestion.length)">
            <div class="autosuggestion block">
              <ul>
                <li>
                  <span class="name">No Results</span>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-container>

      </div>


      <!-- <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput [formControl]='searchQuery' class="search-components textBox" type="text" 
        placeholder="{{placeHolderText ? placeHolderText : 'Search here..'}}"
          [(ngModel)]="str" (keydown)="onKeydown($event)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />
        
      </div> -->
    </div>
  </div>



  <div class="searchBlock">
    
    <div class="searchSection" *ngIf="page_id !='all_related_stories_embed'">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput [formControl]='searchQuery' class="search-components textBox" type="text" 
        placeholder="{{placeHolderText ? placeHolderText : 'Search here..'}}"
          [(ngModel)]="str" (keydown)="onKeydown($event)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />

         
        <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
          <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
            <ul>
              <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                <li [class.active]="i == arrowkeyLocation">
                  <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
    <!-- for amazon embed list -->
    <div class="searchSection" *ngIf="page_id=='all_related_stories_embed'">
      <i class="icon-search"></i>
      <div class="searchtxt">
        <input #listingInput [formControl]='searchQuery' class="search-components textBox" type="text" 
        placeholder="{{placeHolderText ? placeHolderText : 'Search here..'}}"
          [(ngModel)]="str" (keydown)="onKeydownEmbed($event)" (focus)="searchFocus = true" (focusout)="searchFocus = false"
          autofocus />
        <ng-container *ngIf="listSuggestionArray && listSuggestionArray.length > 0">
          <div [ngClass]="(showSuggestionBox) ? 'block' : '' " class="autosuggestion" *ngIf="listSuggestionArray">
            <ul>
              <ng-container *ngFor="let item of listSuggestionArray; let i = index ; trackBy: trackByName; ">
                <li [class.active]="i == arrowkeyLocation">
                  <span class="name" (click)="getsearchResults(item)">{{item}}</span>
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
    <div class="filterSection spImg" *ngIf="page_id !== 'podcast'">
      <i class="icon-filter"></i>
      <div class="fliterBlock">
        <div class="searchfilter" *ngIf="page_id === 'all_stories' || page_id === 'my_workspace' || page_id === 'wires' || page_id === 'print_wires' ||  page_id === 'pulse_wires' || page_id === 'ht_digital_wires'">
          <span [class]="exactMatch ? 'exact green' : 'exact'" (click)="toggleSwitch('exact')" tabindex="0" (keydown)="callToggles($event, 'exact')">
            Exact & Latest
          </span>
        </div>
        <ul class="filterOption">
          <ng-container *ngIf="filterList !== 'false' && facets">
            <ng-container *ngFor="let filter of filterList;let i = index">
              <li [class]="(i <= 3) ? 'togfilt block' : (i > 3 && showMore) ? 'togfilt block' : 'togfilt none'">
              
                <filter [filterType]="filter.type" [displayName]="filter.name" [data]="getFilterData(filter.facet_name_meta)"
                  [facetName]="filter.facet_name" [facetNameMeta]="filter.facet_name_meta" [isDataKeyValuePair]="filter.isDataKeyValuePair"
                  [filterId]="filter.filter_id" (filterSelect)="urlUpdate($event)"></filter>
               
              </li>
              <span #moreButtonEl tabindex="0" [class]="(checkFocusInside(moreButtonEl) ? (showMore ? 'morefilterdrop spImg less focused' : 'morefilterdrop spImg more focused') : (showMore ? 'morefilterdrop spImg less' : 'morefilterdrop spImg more'))"
            (click)="(showMore = !showMore)" *ngIf="(filterList.length > 4 ) && i === 3">{{(showMore) ? 'less' : 'more'}}</span>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </div>
    <div class="cleafix"></div>
    <div class="suggessionList" *ngIf="imageSearch && imageSearchBoxOptionEnable">
      <ul>
        <ng-container *ngFor="let suggested of suggestedItems">
          <li [class]="suggested === selectedSuggestedResult ? 'bordered': ''" (click)="appendSuggested(suggested)">
            <div class="descList" >{{suggested}}</div>
          </li>
        </ng-container>
      </ul>
      </div>
    <div class="closebg"></div>
  </div>

  

  <!-- For Amazon Embed -->
<ng-container *ngIf="!hideListing">
<ng-container *ngIf="!isVideoStory">
  <ng-container *ngIf="RelatedStorySearch && page_id=='all_related_stories_embed'">
    <div class="relatedstorylisting">
      <div class="headingsList">
        <ul>
          <ng-container *ngFor="let header of headerList">
          
            <li [class]="header.class">{{header.name}}</li>
          </ng-container>
        </ul>
      </div>
      <div class="contentList" #listSection>
        <!-- <ng-template #loading> -->
          <div style="text-align: center; display: inline-block; width: 100%">
            <!-- <ng-container *ngIf="callFail">
              <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                Sorry, Server Error
              </div>
            </ng-container> -->
           
            <ng-container *ngIf="callFail">
              <div class="imagepreloader">
                <div class="a" style="--n: 5;">
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="emptyList">
              <div>Results not found!</div>
            </ng-container>
          </div>
        <!-- </ng-template> -->

        <ng-template #nores>
          <!-- <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div> -->
        </ng-template>
        <ng-container *ngIf="((1 > amzonEmbedList.length) && (1 > snapdealEmbedList.length) && (1> cromaEmbedList) && (1> affiliateEmbedList) );then nores else listData"></ng-container>
        <ng-template #listData>
            <ng-container *ngIf="amzonEmbedList.length>0">
              <div [dragula]="'fifth-bag'" [dragulaModel]='amzonEmbedList[0].itemsList'>
                <ng-container *ngFor="let item of amzonEmbedList[0].itemsList; trackBy: trackByName; let i = index">
                  <ng-container *ngIf="item && item !== null && item.id != story_Id">
                    <ng-container *ngIf="(!multipleStories) ? (amzonEmbedList[0].itemsList.indexOf(item.itemId) === -1) : true">
                      <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'">

                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <ng-container >

                            <ng-container *ngIf="header.type == 'image'">
                              <ng-container *ngIf="header.conditionOn">
                               
                                <li [class]="header.class">

                                 
                                    <div class="imgblock">
                                      <img class="listCell" height="100px" [src]="item.primaryImageUrl">
                                    </div>
                                 

                                </li>
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'title'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.itemName"></div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'price'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.itemDisplayPrice"></div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            
                            <ng-container *ngIf="header.type == 'action'">
                              <li class="actions">
                                <span>
                                  <label class="checkblock">
                                    
                                    <input type="checkbox" [checked]="item.checked" 
                                    (click)="selectAmazonEmbed(item, multipleStories)">
                                    <span class="checkmark"></span>
                                  </label>
                                </span>
                                <!-- <span class="handle1 sortpara2"><i class="icon-move related-move"></i></span> -->
                              </li>
                            </ng-container>
                          
                          </ng-container>
                        </ng-container>

                      </ul>
                    </ng-container>
                  </ng-container>
                </ng-container>
                </div>
            <!-- <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ng-container *ngIf="item && item !== null && item.id != story_Id">
                <ng-container *ngIf="(!multipleStories) ? (relatedStoryArray.indexOf(item.id) === -1) : true">
                  <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'" (click)="selectStoryId(item, multipleStories)">

                    <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                      <ng-container *ngIf="htmlToPlaintextlisting(getValuefromObject(item,header.model_id)); let dataValue">
                        <ng-container *ngIf="header.type == 'text'">
                          <ng-container *ngIf="header.colorCondition">
                            <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">

                              <span class={{dataValue.toLowerCase()}}>
                                <div class="relhidden">
                                  <div class="listCell" [innerHTML]="dataValue"></div>
                                </div>
                              </span>

                            </li>
                          </ng-container>
                          <ng-container *ngIf="!header.colorCondition && !header.conditionOn">
                            <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                              <ng-container *ngIf="(header.showIcon)">
                                <em class="breakingnews icon-breaking" *ngIf='(item.metadata.breakingNews)'></em>
                                <em class="sponsored icon-Combined-Shape" *ngIf='(item.metadata.sponsored)'></em>
                              </ng-container>
                              <div class="relhidden">
                                <div class="listCell">
                                  <span [innerHTML]="dataValue"></span>
                                </div>
                              </div>
                            </li>
                          </ng-container>
                          <ng-container *ngIf="!header.colorCondition && header.conditionOn">
                            <li [class]="header.class">
                              <small [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                <div class="relhidden">
                                  <div class="listCell" [innerHTML]="dataValue"></div>
                                </div>
                              </small>

                            </li>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="header.type == 'date'">
                          <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</li>
                        </ng-container>
                        <ng-container *ngIf="header.type == 'action'">
                          <li class="actions">
                            <span>
                              <label class="checkblock">
                                <input type="checkbox" (click)="selectStoryId(item, multipleStories)" [checked]="(relatedStoryArray.indexOf(item.id) > -1)">
                                <span class="checkmark"></span>
                              </label>
                            </span>
                          </li>
                        </ng-container>
                        <ng-container *ngIf="header.type == 'mapping'">
                          <li [class]="header.class" [title]="domainMapping[dataValue] ? domainMapping[dataValue]: dataValue">
                            <span [innerHTML]="dataValue !== '-'? domainMapping[dataValue] : '-'"></span>
                          </li>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ul>
                </ng-container>
              </ng-container>
            </ng-container> -->
            </ng-container>

            <ng-container *ngIf="affiliateEmbedList.length>0">
              <div [dragula]="'fifth-bag'" [dragulaModel]='affiliateEmbedList'>
                <ng-container *ngFor="let item of affiliateEmbedList; trackBy: trackByName; let i = index">
                  <ng-container *ngIf="item && item !== null && item.id != story_Id">
                    <ng-container>
                      <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'" (click)="selectAffiliateEmbed(item)">

                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <ng-container >

                            <ng-container *ngIf="header.type == 'image'">
                              <ng-container *ngIf="header.conditionOn">
                               
                                <li [class]="header.class">

                                 
                                    <div class="imgblock">
                                      <img class="listCell" height="100px" [src]="item.productFrontImage">
                                    </div>
                                 

                                </li>
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'title'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.productName"></div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'price'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.discountedPrice"></div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            
                            <ng-container *ngIf="header.type == 'action'">
                              <li class="actions">
                                <span>
                                  <label class="checkblock">
                                    
                                    <input type="checkbox" [checked]="item.checked" 
                                    (click)="selectAffiliateEmbed(item)">
                                    <span class="checkmark"></span>
                                  </label>
                                </span>
                              </li>
                            </ng-container>
                          
                          </ng-container>
                        </ng-container>

                      </ul>
                    </ng-container>
                  </ng-container>
                </ng-container>
                </div>
            </ng-container>

            <ng-container *ngIf="snapdealEmbedList.length>0">
              <div [dragula]="'fifth-bag'" [dragulaModel]='snapdealEmbedList'>
                <ng-container *ngFor="let item of snapdealEmbedList; trackBy: trackByName; let i = index">
                  <ng-container *ngIf="item && item !== null && item.id != story_Id">
                    <ng-container>
                      <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'">

                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <ng-container >

                            <ng-container *ngIf="header.type == 'image'">
                              <ng-container *ngIf="header.conditionOn">
                               
                                <li [class]="header.class">

                                 
                                    <div class="imgblock">
                                      <img class="listCell" height="100px" [src]="item.imageUrl">
                                    </div>
                                 

                                </li>
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'title'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.productName"></div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            <ng-container *ngIf="header.type == 'price'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">

                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.productPrice">Rs.</div>
                                    </div>
                                  </span>

                                </li>
                               
                              </ng-container>
                             
                             
                            </ng-container>
                            
                            <ng-container *ngIf="header.type == 'action'">
                              <li class="actions">
                                <span>
                                  <label class="checkblock">
                                    
                                    <input type="checkbox" [checked]="item.checked" 
                                    (click)="selectSnapdealEmbed(item, multipleStories)">
                                    <span class="checkmark"></span>
                                  </label>
                                </span>
                                <!-- <span class="handle1 sortpara2"><i class="icon-move related-move"></i></span> -->
                              </li>
                            </ng-container>
                          
                          </ng-container>
                        </ng-container>

                      </ul>
                    </ng-container>
                  </ng-container>
                </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="cromaEmbedList.length>0">
              <div [dragula]="'fifth-bag'" [dragulaModel]='cromaEmbedList'>
                <ng-container *ngFor="let item of cromaEmbedList; trackBy: trackByName; let i = index">
                  <ng-container *ngIf="item && item !== null && item.id != story_Id">
                    <ng-container>
                      <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'">
                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <ng-container >
                            <ng-container *ngIf="header.type == 'image'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">
                                    <div class="imgblock">
                                      <img class="listCell" height="100px" [src]="item.imageUrl">
                                    </div>
                                </li>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'title'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">
                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.productName"></div>
                                    </div>
                                  </span>
                                </li>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'price'">
                              <ng-container *ngIf="header.conditionOn">
                                <li [class]="header.class">
                                  <span>
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="item.productPrice">Rs.</div>
                                    </div>
                                  </span>
                                </li>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'action'">
                              <li class="actions">
                                <span>
                                  <label class="checkblock">
                                    <input type="checkbox" [checked]="item.checked" 
                                    (click)="selectCromaEmbed(item, multipleStories)">
                                    <span class="checkmark"></span>
                                  </label>
                                </span>
                              </li>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </ul>
                    </ng-container>
                  </ng-container>
                </ng-container>
                </div>
            </ng-container>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!RelatedStorySearch && page_id !== 'podcast'">
    <ng-container *ngIf="by_photoListing;then showphotoListing else showListing"> </ng-container>
    <ng-template #showListing>
      <div class="headingsList">
        <ul>
          <ng-container *ngFor="let header of headerList">
            <!-- <li [class]="header.class" *ngIf="header.header_id == 'pickUp' && domain == '5cd513942990d521f440136f'">Translate</li> -->
            <li [class]="header.class">{{header.name}}</li>
          </ng-container>
        </ul>
      </div>
      <div class="contentList">
        <ng-template #loading>
          <div style="text-align: center; display: inline-block; width: 100%;">
            <ng-container *ngIf="callFail">
              <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                Sorry, Server Error
              </div>
            </ng-container>
            <ng-container *ngIf="!callFail">
              <div class="imagepreloader">
                <div class="a" style="--n: 5;">
                  <!-- Up dots -->
                  <div class="dot dot1" style="--i: 0;"></div>
                  <div class="dot dot2" style="--i: 1;"></div>
                  <div class="dot dot3" style="--i: 2;"></div>
                  <div class="dot dot4" style="--i: 3;"></div>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-template>

        <ng-template #nores>
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
        </ng-template>
        <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
        <ng-template #listData>
          <ng-container *ngIf="listArray.length > 0;else loading">
            <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
              <ng-container *ngIf="0 > page_id.indexOf('wire')">
                <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
                  <div class='story_status'>
                    <em #unlockDropdown [class]="getclassonCondition(item.lockedByUserId,
                    page_id != 'pages' && item.metadata ? item.metadata.status : item.status)"
                      (click)="openOptions(i)">
                      <div class="arrow_box single" *ngIf="(item.lockedByUserId && unlockOptions !== i)">{{item.lockedByUserName}}</div>
                      <div class="revertStoryBlock" *ngIf="unlockOptions === i">
                        <ul *ngIf="item.type !== 'video'">
                          <li>
                            <button (click)="openUnlock(i)">Unlock</button>
                          </li>
                          <li>
                            <button (click)="copyUrl(i)">Copy Url</button>
                          </li>
                        </ul>
                        <ul *ngIf="item.type === 'video'">
                          <li *ngIf="item.lockedByUserId">
                            <button (click)="openUnlock(i)">Unlock</button>
                          </li>
                          <li>
                            <button (click)="copyUrl(i)">Copy Url</button>
                          </li>
                          <li>
                            <button id="Embed_btn" (click)="copyEmbed(clipboardInput)">Copy Embed</button>
                          </li>
                        </ul>
                      </div>
                    </em>
                    <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(item.imageAmpValidated)  ? 'ValidatedAmpImage' : 'NotValidatedAmpImage icon-image'"></em>
                    <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(item.metadata.markUnimportant)  ? 'notimportant icon-unimportant-active' : 'important icon-unimportant-inactive'"></em>

                  </div>


                  <ul [class.active]="!item.lockedByUserId" class="listingul"  #listData2>
                    <a #listEl tabindex="0" [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''" [queryParams]="{ 'domain': domain }">
                      <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                        <ng-container *ngIf="htmlToPlaintextlisting(getValuefromObject(item,header.model_id)); let dataValue">
                          <ng-container *ngIf="header.type == 'status' && item && item !== null && item.hasOwnProperty('metadata')">
                            <li *ngIf="item.metadata.killed" [class]="header.class">
                              <span class="killed">
                                KILLED
                              </span>
                            </li>
                            <li *ngIf="!item.metadata.killed" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                              <span class={{dataValue.toLowerCase()}}>
                                {{dataValue}}
                              </span>
                            </li>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'text'">
                            <ng-container *ngIf="header.colorCondition">
                              <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">

                                <span class={{dataValue.toLowerCase()}}>
                                  {{dataValue}}
                                </span>

                              </li>
                            </ng-container>
                            <ng-container *ngIf="!header.colorCondition && !header.conditionOn">
                              <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                <ng-container *ngIf="(header.showIcon)">
                                  <em class="breakingnews icon-breaking" *ngIf='(item.metadata.breakingNews)'></em>
                                  <em class="sponsored icon-Combined-Shape" *ngIf='(item.metadata.sponsored)'></em>
                                </ng-container>
                                <!-- <ng-container *ngIf="(header.lockpage && item.lockedByUserId)">
                                  <em class="lockedIcon icon-lock">
                                    <div class="arrow_box single">{{item.lockedByUserId}}</div>
                                  </em>
                                </ng-container> -->
                                <div class="relhidden">
                                  <div class="listCell" title="{{dataValue !== '-'? dataValue.trim() :'-'}}">{{dataValue
                                    | titlecase}}</div>
                                </div>
                              </li>
                            </ng-container>
                            <ng-container *ngIf="!header.colorCondition && header.conditionOn">
                              <li [class]="header.class">
                                <small [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                  <div class="relhidden">
                                    <div class="listCell" [innerHTML]="dataValue"></div>
                                  </div>
                                </small>
                              </li>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'url'">

                            <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                              <div class="relhidden">
                                <div class="listCell" title="{{dataValue !== '-'? dataValue.trim() :'-'}}">{{dataValue}}</div>
                              </div>
                            </li>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'date'">
                            <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-' }}</li>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </a>
                    <div [class]="toggleArry.indexOf(item.id) > -1 ? 'revertStoryBlock pagenavdrop active' : 'revertStoryBlock pagenavdrop'" id="page_{{item.id}}" *ngIf="page_id.indexOf('page') > -1">
                      <ul>
                        <li><a href="/dash/page/nav-manager/{{item.id}}">Top Nav</a></li>

                        <li *ngIf="showSubNav()"><a href="/dash/page/sub-nav-manager/{{item.id}}">Sub Nav</a></li>
                        <li><a href="/dash/page/{{item.id}}">Manage</a></li>
                      </ul>
                    </div>
                    <li *ngIf="page_id.indexOf('page') > -1" class="relative pagemoredot" (click)="showNav(item.id)">
                      <span class="threedots"><span></span><span></span><span></span></span>
                    </li>
                  </ul>
                </div>
              </ng-container>
              <ng-container *ngIf="page_id.indexOf('wire') > -1">
                <!-- <div class="wire-story-preview" #wireRef
                  [storyId]="item.id" [data]="item" pageId="wires" allApi="one_story" [headers]="headerList"
                  (sendPreviewId)="setFocusListItem($event)"
                  [byAgencyIn]="byAgencyWire ? byAgencyWire : null"></div> -->

                <ul #listEl tabindex="0" [class]="(checkFocusInside(listEl)) ? 'locked rssfeedul  focused' : 'locked rssfeedul'"
                  [class.active]="!item.lockedByUser" (keydown)="openPreviewIfFocused($event, listEl, item)">
                  <ng-container *ngFor="let header of headerList; trackBy: trackByName">
                    <ng-container *ngIf="getValuefromObject(item,header.model_id); let dataValue">
                      <!-- <p>{{dataValue}}</p> -->
                      <ng-container *ngIf="header.type == 'text'">
                        <ng-container *ngIf="header.conditionOn && item[header.conditionOn];then withIcon else withoutIcon">
                        </ng-container>
                        <ng-template #withIcon>
                          <li (click)="openPreview(item)" [class]="header.class + ' spImg'" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                            <div class="relhidden">
                              <div class="listCell">{{dataValue ? dataValue : ''}}</div>
                            </div>
                          </li>
                        </ng-template>
                        <ng-template #withoutIcon>
                          <ng-container *ngIf="header.colorCondition">
                            <li (click)="openPreview(item)" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                              <span class={{dataValue.toLowerCase()}}>
                                {{dataValue}}
                              </span>
                            </li>
                          </ng-container>

                          <ng-container *ngIf="!header.colorCondition">
                            <li (click)="openPreview(item)" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                              <div class="relhidden">
                                <div class="listCell">{{dataValue ? dataValue : ''}}</div>
                              </div>
                            </li>
                          </ng-container>
                        </ng-template>
                      </ng-container>

                      <ng-container *ngIf="header.type == 'date'">
                        <li (click)="openPreview(item)" [class]="header.class">
                          <div class="relhidden">
                            <div class="listCell">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</div>
                          </div>
                        </li>
                      </ng-container>


                      <ng-container *ngIf="header.type == 'date_day'">
                        <li (click)="openPreview(item)" [class]="header.class">
                          <div class="relhidden">
                            <div class="listCell">{{dataValue !== '-'?getNewTypeDateDay(dataValue):'-'}}</div>
                          </div>
                        </li>
                      </ng-container>

                      <ng-container *ngIf="header.type == 'component' && header.header_id == 'pickUp'">
                        <li class="pickUp">
                         <!-- <span class="pickStory icon-translate" *ngIf="type3">
                            <div class="arrow_box multiple">
                              <ul>
                                <li>Select Language</li>
                                <li *ngFor="let language of targetLaguages" (click)="openStoryEdit(item, language.id)">{{language.name}}</li>
                              </ul>
                            </div>
                          </span> -->
                          <ng-container *ngIf="type3">
                              <span class="pickStory icon-pickup"
                              *ngFor="let language of targetLaguages"
                                (click)="openStoryEdit(item, language.id)"  >
    
                              </span>
                            </ng-container>
    
                          <ng-container *ngIf="type2">
                          <span class="pickStory icon-pickup"
                          *ngFor="let language of targetLaguages"
                            (click)="openStoryEdit(item, language.id)"  >

                          </span>
                        </ng-container>
                          <ng-container  *ngIf="type1">
                          <span class="pickStory icon-pickup" *ngFor="let language of targetLaguages"
                            (click)="openStoryEdit(item, language.id)" >
                          <div class="arrow_box single">Pick as Story</div></span>
                          </ng-container>

                          <!-- pickLink green icon-link -->

                            <span [class]="'pickLink' + (checkIfOnePublished(item) ? ' green' : '') + ' icon-link'"
                             *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                              <!-- {{item ? item.agency : 'temporary'}} -->
                              <ng-container *ngIf="item.wirePublishedStories.length > 1">
                                <div class="arrow_box multiple">
                                  <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                                    <ng-container *ngIf="pickedStory">
                                      <ul>
                                        <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain"  >
                                          <div [class]="((pickedStory.metadata && pickedStory.metadata.status && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                            {{pickedStory.title ? pickedStory.title : ''}}</div>
                                          <div class="writername">{{(pickedStory.metadata != null &&
                                            pickedStory.metadata.authors != null && pickedStory.metadata.authors.length >
                                            0) ?
                                            pickedStory.metadata.authors[0]
                                            : '-'}}</div>
                                        </li>
                                      </ul>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="item.wirePublishedStories.length === 1">
                                <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">{{item.wirePublishedStories[0].title ?
                                  item.wirePublishedStories[0].title : ''}}</div>
                              </ng-container>
                            </span>

                        </li>
                      </ng-container>
                      <ng-container *ngIf="header.type == 'component' && header.header_id == 'pickURL'">
                          <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(dataValue)"></span>
                       </li>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ul>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-template>
      </div>
    </ng-template>

   
</ng-container>
</ng-container>
<div *ngIf="isVideoStory || page_id == 'podcast'">
  <ng-template #loading>
    <div style="text-align: center; display: inline-block; width: 100%;position: absolute; top: 65%; left: 10%;">
      <ng-container *ngIf="callFail">
        <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
          Sorry, Server Error
        </div>
      </ng-container>
      <ng-container *ngIf="!callFail">
        <div class="imagepreloader">
          <div class="a" style="--n: 5;">
            <div class="dot dot1" style="--i: 0;"></div>
            <div class="dot dot2" style="--i: 1;"></div>
            <div class="dot dot3" style="--i: 2;"></div>
            <div class="dot dot4" style="--i: 3;"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #nores>
    <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px; height: 100vh; border-top: 1px solid #ddd;">No Data</div>
  </ng-template>
  <ng-container *ngIf="((noresults == true) && (1 > videoList.length));then nores else listData"></ng-container>
  <ng-template #listData>

    <ng-container *ngIf="(page_id == 'videoServiceStory') && isVideoStory">
      <ng-container *ngIf="listArray.length > 0;else loading"></ng-container>
      <div class="videodisplayView">
        <ul class="viewdisplay">
          <li [class.active]="selectedItem == 'gridView'" (click)="setView('gridView')"><i class="icon-grid"></i></li>
          <li [class.active]="selectedItem == 'listView'" (click)="setView('listView')"><i class="icon-list" id="listViewIcon"></i> </li>
        </ul>
      </div>
      <div class="listgrid videoslist" *ngIf="selectedItem == 'gridView'">
        <div class="videoslistBlock">
          <ng-container *ngFor="let smallList of multiList">
            <ul class="videolist">
              <!-- <li *ngFor="let video of smallList" (deferLoad)="video.show = true"> -->
              <li *ngFor="let video of smallList">
                <div class="imageblock">
                  <div class="image">
                    <!-- <ng-container *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images && video.show; then srcimageS else nosrcimageS"></ng-container> -->
                    <ng-container *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images; then srcimageS else nosrcimageS"></ng-container>
                    <ng-template #srcimageS>
                      <div class="imagecontain"><img [src]="sharedService.getImageOnPriority(video.leadMedia.image.images, '600x338')" alt=""></div>
                    </ng-template>
                    <ng-template #nosrcimageS>
                      <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt=""></div>
                    </ng-template>
                  </div>
                  <div class="imageInfo">
                    <div class="status"><span [class]="video.metadata.status">{{video.metadata.status}}</span></div>
                    <div class="heading"><a href="" [routerLink]="routeLinkForList !== 'false' && isVideoModal === false ? routeLinkForList + '/' + video.id : ''">{{video.title}}</a></div>
                    <div class="statusaction"><span class="date">{{getNewTypeDate(video.createdDate)}}</span>
                      <span class="actions fr">
                        <span class="edit"  [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + video.id : ''" (click)="videoPickEvent((routeLinkForList !== 'false' ? routeLinkForList + '/' + video.id : ''))"><i class="icon-pickup"></i><div class="arrow_box single">Edit Story</div></span>
                        <span class="video_icon" (click)="openVideoModal(video, $event)"><i class="icon-play-regular"></i><div class="arrow_box single">Open Preview</div></span>
                      </span></div>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </div>
      <div class="listdetail videosdetaillist" *ngIf="selectedItem == 'listView'">
        <div class="headingsList">
          <ul class="">
            <li class="video">Video</li>
            <li class="caption">Title</li>
            <li class="createdon">Created By</li>
            <li class="lastupdatedon">Last Updated On</li>
            <li class="updatedBy">Updated By</li>
            <li class="status">Status</li>
          </ul>
        </div>
        <div class="contentList">
          <div class="storyListing" *ngFor="let video of listArray; trackBy: trackByName; let i = index">
            <div class='story_status'>
              <em #unlockDropdown [class]="getclassonCondition(video.lockedByUserId,
                      page_id != 'pages' && video.metadata ? video.metadata.status : video.status)"
                (click)="openOptions(i)">
                <div class="arrow_box single" *ngIf="(video.lockedByUserId && unlockOptions !== i)">{{video.lockedByUserId}}</div>
                <div class="revertStoryBlock" *ngIf="unlockOptions === i">
                  <ul *ngIf="video.type !== 'video'">
                    <li>
                      <button (click)="openUnlock(i)">Unlock</button>
                    </li>
                    <li>
                      <button (click)="copyUrl(i)">Copy Url</button>
                    </li>
                  </ul>
                  <ul *ngIf="video.type === 'video'">
                    <li *ngIf="video.lockedByUserId">
                      <button (click)="openUnlock(i)">Unlock</button>
                    </li>
                    <li>
                      <button (click)="copyUrl(i)">Copy Url</button>
                    </li>
                    <li>
                      <button id="Embed_btn" (click)="copyEmbed(clipboardInput)">Copy Embed</button>
                    </li>
                  </ul>
                </div>
              </em>
              <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(video.metadata.markUnimportant)  ? 'notimportant icon-unimportant-active' : 'important icon-unimportant-inactive'"></em>
            </div>
            <ul class="list">
              <a #listEl tabindex="0" (click)="routeToLink(video.id)">
                <li class="video">
                  <div class="imagecontain" *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images"><img
                      [src]="sharedService.getImageOnPriority(video.leadMedia.image.images, '600x338')" alt=""><i class="icon-play-regular"
                      (click)="openVideoModal(video, $event)"></i></div>
                  <div class="imagecontain" *ngIf="!video.leadMedia || !video.leadMedia.image || !video.leadMedia.image.images"><img
                      src="../../../assets/images/404.jpg" alt=""><i class="icon-play-regular" (click)="openVideoModal(video, $event)"></i></div>
                </li>
                <li class="caption">
                  <div class="relhidden">
                    <div class="listCell">{{video.title}}</div>
                  </div>
                </li>
                <li class="createdBy">
                  <div class="relhidden">
                    <div class="listCell">{{video.createdBy}}</div>
                  </div>
                </li>
                <li class="lastupdatedon">
                  <div class="relhidden">
                    <div class="listCell">{{getNewTypeDate(video.lastModifiedDate)}}</div>
                  </div>
                </li>
                <li class="updatedBy">
                  <div class="relhidden">
                    <div class="listCell">{{video.lastModifiedByUserName}}</div>
                  </div>
                </li>
                <li class="status">
                  <div class="listCell"><span [class]="video.metadata.status">{{video.metadata.status}}</span></div>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>

    <!--ng-container *ngIf="(page_id == 'slideVideoListing' && isVideoStory)">
      <ng-container *ngIf="videoList.length > 0;else loading"></ng-container>
      <div class="listgrid videoslist">
        <div class="videoslistBlock">
          <ng-container *ngFor="let smallList of multiList">
            <ul class="videolist">
                <li *ngFor="let video of smallList" (deferLoad)="video.show = true">
                <div class="imageblock">
                  <div class="image" (mouseenter)="showVideoGalleryListing ? onHovering($event) : false">
                    <ng-container>
                      <div class="imagecontain"><img [src]="video.url">
                        <span class="hover" *ngIf="showVideoGalleryListing">
                            <button class="blue" (click)="sendVideoToParent(video)">Use
                              Video</button>
                          </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
                </li>
            </ul>
          </ng-container>
        </div>
      </div>
    </ng-container-->

    <!-- <ng-container *ngIf="(page_id == 'videoStory' && isVideoStory)">
      <ng-container *ngIf="videoList.length > 0;else loading"></ng-container>
      <div class="listgrid videoslist">
        <div class="videoslistBlock">
          <ng-container *ngFor="let smallList of multiList">
            <ul class="videolist">
                
                <li *ngFor="let video of smallList" (deferLoad)="video.show = true">
                <div class="imageblock">
                  <div class="image" (mouseenter)="showVideoGalleryListing ? onHovering($event) : false">
                    <ng-container *ngIf="video.images && video.images.img_480 && video.show; then srcimage else nosrcimage"></ng-container>
                    <ng-template #srcimage>
                      <div class="imagecontain"><img [src]="video.images.img_480" alt="">
                        <span class="hover" *ngIf="showVideoGalleryListing">
                            <button class="blue" (click)="sendVideoToParent(video)">Use
                              Video</button>
                          </span>
                      </div>
                    </ng-template>
                    <ng-template #nosrcimage>
                      <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt="">
                        <span class="hover" *ngIf="showVideoGalleryListing">
                            <button class="blue" (click)="sendVideoToParent(video)">Use
                              Video</button>
                          </span>
                      </div>
                    </ng-template>
                  </div>
                  <div class="imageInfo">
                    <div class="status" *ngIf="page_id == 'videoServiceStory'"><span class="edited">Edited</span></div>
                    <div class="heading">{{video.name}}</div>
                    <div class="statusaction" *ngIf="!showVideoGalleryListing"><span class="date">{{getNewTypeDate(video.updated_at)}}</span>
                      <span class="actions fr">
                        <span class="edit" (click)="editVideo(video)"><i class="icon-pickup"></i><div class="arrow_box single">Pick as Story</div></span>
                        <span class="video_icon" (click)="openVideoModal(video, $event)"><i class="icon-play-regular"></i><div class="arrow_box single">Open Preview</div></span>
                      </span></div>
                  </div>
                </div>
                </li>
              
            
            </ul>
          </ng-container>
        </div>
      </div>
    </ng-container> -->


    <!-- Podcast 2nd -->

    <ng-container *ngIf="page_id == 'podcast'">
      <ng-container *ngIf="podcastEpisodesList.length > 0;else loading"></ng-container>
      <div class="listgrid videoslist">
        <div class="videoslistBlock">
          <!-- <ng-container *ngFor="let smallList of podcastList"> -->
            <div class="podCastList">
              <div *ngFor="let podcast of podcastEpisodesList">
                <h3>{{podcast.podcast.title}}</h3>
                <!-- <div class="">
                  <div class="image">
                    <ng-container *ngIf="podcast.podcast.podcast_image; then srcimage else nosrcimage"></ng-container>
                    <ng-template #srcimage>
                      <div class="imagecontain"><img [src]="podcast.podcast.podcast_image" alt="">
                      </div>
                    </ng-template>
                    <ng-template #nosrcimage>
                      <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt="">
                      </div>
                    </ng-template>
                  </div>
                </div>  -->

                <!-- <div class="col-md-8">
                  <div class="imageInfo">
                    <div>{{podcast.podcast.title}}</div>
                  </div>
                </div> -->
                
                <ul class="podCastEpisodesList">
                  <ng-container *ngIf="podcast.episodes.length > 0">
                    <li *ngFor="let episode of podcast.episodes">
                      <div class="imageblock">
                        <div class="image" (mouseenter)="onHovering($event)">
                          <ng-container *ngIf="episode.episode_image; then srcimage else nosrcimage"></ng-container>
                          <ng-template #srcimage>
                            <div class="imagecontain"><img [src]="episode.episode_image" alt="">
                              <span class="hover">
                                  <button class="blue" (click)="sendPodcastToParent(episode)">Use
                                    Podcast</button>
                                </span>
                            </div>
                          </ng-template>
                          <ng-template #nosrcimage>
                            <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt="">
                              <span class="hover">
                                  <button class="blue" (click)="sendPodcastToParent(episode)">Use
                                    Podcast</button>
                                </span>
                            </div>
                          </ng-template>
                        </div>
                        <div class="imageInfo">
                          <!-- <div class="status" *ngIf="page_id == 'videoServiceStory'"><span class="edited">Edited</span></div> -->
                          <div class="heading">{{episode.title}}</div>
                          <!-- <div class="statusaction" *ngIf="!showVideoGalleryListing"><span class="date">{{getNewTypeDate(video.updated_at)}}</span>
                            <span class="actions fr">
                              <span class="edit" (click)="editVideo(video)"><i class="icon-pickup"></i><div class="arrow_box single">Pick as Story</div></span>
                              <span class="video_icon" (click)="openVideoModal(video, $event)"><i class="icon-play-regular"></i><div class="arrow_box single">Open Preview</div></span>
                            </span></div> -->
                        </div>
                      </div>
                    </li>
                  </ng-container>
                  <ng-container *ngIf="1 > podcast.episodes.length">
                        <h2 class="noresult-heading" style="text-align: center;padding: 30px;">No result found</h2>
                  </ng-container>
                
              </ul>
                
              </div>
            </div>
          <!-- </ng-container> -->
        </div>
      </div>
    </ng-container>

    <!-- Podcast 2nd -->


    <div class="viewVideoPreview lightBox block" *ngIf="openVideoPreview">
      <div class="headerLight">
        <div class="close fl spImg" (click)="closeVideoPreview()"></div>
      </div>
      <ng-container class="showVideoMessage" *ngIf="previewUrl == null">
        <div class="readstory block">
          <div class="unlockStory">
            <div class="wid100 pad30">
              <h1>Video does not exist...</h1>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="previewUrl !== null">
        <div class="lightContent">
          <div class="detialimageViw">
            <div _ngcontent-c6="" class="imagesPart">
              <iframe appIframeTracker #previewFrame [src]="previewUrl" [style]="iframeStyle" (load)="iframeLoaded($event)"></iframe>
            </div>
            <div class="imageContent">
              <h3> {{videDesc}}</h3>
              <label>Created in BrightCove on</label>
              <p>{{getNewTypeDate(videoCreated)}}</p>
              <label>Channel</label>
              <p>{{videoChannel}}</p>
              <div class="phtototags">
                <label>Tags</label>
                <ul>
                  <li *ngFor="let tag of tags"> {{tag}} </li>
                </ul>
              </div>
              <div class="width100 fl btnBlock">
                <button name="Insert Video" *ngIf="page_id === 'videoStory'" (click)="insertVideo()">Insert Video</button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
</ng-container>
<!-- For Related Story -->
<ng-container *ngIf="!hideListing">
  <ng-container *ngIf="!isVideoStory">
    <!-- related story listing -->
    <ng-container *ngIf="RelatedStorySearch && page_id !='all_related_stories_embed'">
      <div class="relatedstorylisting">
        <div class="headingsList">
          <ul>
            <ng-container *ngFor="let header of headerList">
              <li [class]="header.class">{{header.name}}</li>
            </ng-container>
          </ul>
        </div>
        <div class="contentList" #listSection>
          <ng-template #loading>
            <div style="text-align: center; display: inline-block; width: 100%">
              <ng-container *ngIf="callFail">
                <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                  Sorry, Server Error
                </div>
              </ng-container>
              <ng-container *ngIf="!callFail">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>
<!-- Related story element -->
          <ng-template #nores>
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
          </ng-template>
          <ng-container *ngIf="((noresults == true) && (1 > relatedSelectedArray.length));then nores else listData"></ng-container>
          <ng-template #listData>
              <ng-container *ngIf="(relatedSelectedArray.concat(listArray)).length > 0;else loading">
                <div [dragula]="'fifth-bag'" [dragulaModel]='relatedSelectedArray'>
                  <ng-container *ngFor="let item of relatedSelectedArray; trackBy: trackByName; let i = index">
                    <ng-container *ngIf="item && item !== null && item.id != story_Id">
                      <ng-container *ngIf="(!multipleStories) ? (relatedStoryArray.indexOf(item.id) === -1) : true">
                        <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'" (click)="selectStoryId(item, multipleStories)">

                          <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                            <ng-container *ngIf="htmlToPlaintextlisting(getValuefromObject(item,header.model_id)); let dataValue">
                              <ng-container *ngIf="header.type == 'text'">
                                <ng-container *ngIf="header.colorCondition">
                                  <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">

                                    <span class={{dataValue.toLowerCase()}}>
                                      <div class="relhidden">
                                        <div class="listCell" [innerHTML]="dataValue"></div>
                                      </div>
                                    </span>

                                  </li>
                                </ng-container>
                                <ng-container *ngIf="!header.colorCondition && !header.conditionOn">
                                  <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                                    <ng-container *ngIf="(header.showIcon)">
                                      <em class="breakingnews icon-breaking" *ngIf='(item.metadata.breakingNews)'></em>
                                      <em class="sponsored icon-Combined-Shape" *ngIf='(item.metadata.sponsored)'></em>
                                    </ng-container>
                                    <div class="relhidden">
                                      <div class="listCell">
                                        <span [innerHTML]="dataValue"></span>
                                      </div>
                                    </div>
                                  </li>
                                </ng-container>
                                <ng-container *ngIf="!header.colorCondition && header.conditionOn">
                                  <li [class]="header.class">
                                    <small [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                      <div class="relhidden">
                                        <div class="listCell" [innerHTML]="dataValue"></div>
                                      </div>
                                    </small>

                                  </li>
                                </ng-container>
                              </ng-container>
                              <ng-container *ngIf="header.type == 'date'">
                                <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</li>
                              </ng-container>
                              <ng-container *ngIf="header.type == 'action'">
                                <li class="actions">
                                  <span>
                                    <label class="checkblock">
                                      <input type="checkbox" (click)="selectStoryId(item, multipleStories)" [checked]="(relatedStoryArray.indexOf(item.id) > -1)">
                                      <span class="checkmark"></span>
                                    </label>
                                  </span>
                                  <span class="handle1 sortpara2"><i class="icon-move related-move"></i></span>
                                  <!-- <ng-container *ngIf="relatedStoryType==='alsoread'">
                                    <span class="handle1 sortpara2" title="Edit headline on frontend" (click)="videoPickEvent((routeLinkForList !== 'false' ? routeLinkForList + '/' + video.id : ''))"><i class="icon-pickup"></i></span>
                                  </ng-container> -->
                                  
                                  <!-- vb -->
                                </li>
                              </ng-container>
                              <ng-container *ngIf="header.type == 'mapping'">
                                <li [class]="header.class" [title]="domainMapping[dataValue] ? domainMapping[dataValue]: dataValue">
                                  <span [innerHTML]="dataValue !== '-'? domainMapping[dataValue] : '-'"></span>
                                </li>
                              </ng-container>
                            </ng-container>
                          </ng-container>

                        </ul>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  </div>
              <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
                <ng-container *ngIf="item && item !== null && item.id != story_Id">
                  <ng-container *ngIf="(!multipleStories) ? (relatedStoryArray.indexOf(item.id) === -1) : true">
                    <ul #listEl tabindex="0"  [class.active]="!item.lockedByUserId" [class]="'listingul'" (click)="selectStoryId(item, multipleStories)">

                      <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                        <ng-container *ngIf="htmlToPlaintextlisting(getValuefromObject(item,header.model_id)); let dataValue">
                          <ng-container *ngIf="header.type == 'text'">
                            <ng-container *ngIf="header.colorCondition">
                              <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">

                                <span class={{dataValue.toLowerCase()}}>
                                  <div class="relhidden">
                                    <div class="listCell" [innerHTML]="dataValue"></div>
                                  </div>
                                </span>

                              </li>
                            </ng-container>
                            <ng-container *ngIf="!header.colorCondition && !header.conditionOn">
                              <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                                <ng-container *ngIf="(header.showIcon)">
                                  <em class="breakingnews icon-breaking" *ngIf='(item.metadata.breakingNews)'></em>
                                  <em class="sponsored icon-Combined-Shape" *ngIf='(item.metadata.sponsored)'></em>
                                </ng-container>
                                <div class="relhidden">
                                  <div class="listCell">
                                    <span [innerHTML]="dataValue"></span>
                                  </div>
                                </div>
                              </li>
                            </ng-container>
                            <ng-container *ngIf="!header.colorCondition && header.conditionOn">
                              <li [class]="header.class">
                                <small [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                  <div class="relhidden">
                                    <div class="listCell" [innerHTML]="dataValue"></div>
                                  </div>
                                </small>

                              </li>
                            </ng-container>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'date'">
                            <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</li>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'action'">
                            <li class="actions">
                              <span>
                                <label class="checkblock">
                                  <input type="checkbox" (click)="selectStoryId(item, multipleStories)" [checked]="(relatedStoryArray.indexOf(item.id) > -1)">
                                  <span class="checkmark"></span>
                                </label>
                              </span>
                            </li>
                          </ng-container>
                          <ng-container *ngIf="header.type == 'mapping'">
                            <li [class]="header.class" [title]="domainMapping[dataValue] ? domainMapping[dataValue]: dataValue">
                              <span [innerHTML]="dataValue !== '-'? domainMapping[dataValue] : '-'"></span>
                            </li>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                    </ul>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!RelatedStorySearch && page_id !== 'podcast'">
      <ng-container *ngIf="by_photoListing;then showphotoListing else showListing"> </ng-container>
      <ng-template #showListing>
        <div class="headingsList">
          <ul>
            <ng-container *ngFor="let header of headerList">
              <!-- <li [class]="header.class" *ngIf="header.header_id == 'pickUp' && domain == '5cd513942990d521f440136f'">Translate</li> -->
              <li [class]="header.class">{{header.name}}</li>
            </ng-container>
          </ul>
        </div>
        <div class="contentList">
          <ng-template #loading>
            <div style="text-align: center; display: inline-block; width: 100%;">
              <ng-container *ngIf="callFail">
                <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                  Sorry, Server Error
                </div>
              </ng-container>
              <ng-container *ngIf="!callFail">
                <div class="imagepreloader">
                  <div class="a" style="--n: 5;">
                    <!-- Down dots -->
                    <div class="dot dot1" style="--i: 0;"></div>
                    <div class="dot dot2" style="--i: 1;"></div>
                    <div class="dot dot3" style="--i: 2;"></div>
                    <div class="dot dot4" style="--i: 3;"></div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-template>

          <ng-template #nores>
            <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
          </ng-template>
          <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
          <ng-template #listData>
            <ng-container *ngIf="listArray.length > 0;else loading">
              <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
                <ng-container *ngIf="0 > page_id.indexOf('wire')">
                  <div #dive [class]="(checkFocusInside(dive)) ? 'storyListing focused' : 'storyListing'">
                    <div class='story_status'>
                      <em #unlockDropdown [class]="getclassonCondition(item.lockedByUserId,
                      page_id != 'pages' && item.metadata ? item.metadata.status : item.status)"
                        (click)="openOptions(i)">
                        <div class="arrow_box single" *ngIf="(item.lockedByUserId && unlockOptions !== i)">{{item.lockedByUserName}}</div>
                        <div class="revertStoryBlock" *ngIf="unlockOptions === i">
                          <ul *ngIf="item.type !== 'video'">
                            <li>
                              <button (click)="openUnlock(i)">Unlock</button>
                            </li>
                            <li>
                              <button (click)="copyUrl(i)">Copy Url</button>
                            </li>
                          </ul>
                          <ul *ngIf="item.type === 'video'">
                            <li *ngIf="item.lockedByUserId">
                              <button (click)="openUnlock(i)">Unlock</button>
                            </li>
                            <li>
                              <button (click)="copyUrl(i)">Copy Url</button>
                            </li>
                            <li>
                              <button id="Embed_btn" (click)="copyEmbed(clipboardInput)">Copy Embed</button>
                            </li>
                          </ul>
                        </div>
                      </em>
                      <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(item.imageAmpValidated)  ? 'ValidatedAmpImage' : 'NotValidatedAmpImage icon-image'"></em>
                      <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(item.metadata.markUnimportant)  ? 'notimportant icon-unimportant-active' : 'important icon-unimportant-inactive'"></em>

                    </div>


                    <ul [class.active]="!item.lockedByUserId" class="listingul"  #listData2>
                      <a #listEl tabindex="0" [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + item.id : ''" [queryParams]="{ 'domain': domain }">
                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <ng-container *ngIf="htmlToPlaintextlisting(getValuefromObject(item,header.model_id)); let dataValue">
                            <ng-container *ngIf="header.type == 'status' && item && item !== null && item.hasOwnProperty('metadata')">
                              <li *ngIf="item.metadata.killed" [class]="header.class">
                                <span class="killed">
                                  KILLED
                                </span>
                              </li>
                              <li *ngIf="!item.metadata.killed" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                <span class={{dataValue.toLowerCase()}}>
                                  {{dataValue}}
                                </span>
                              </li>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'text'">
                              <ng-container *ngIf="header.colorCondition">
                                <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">

                                  <span class={{dataValue.toLowerCase()}}>
                                    {{dataValue}}
                                  </span>

                                </li>
                              </ng-container>
                              <ng-container *ngIf="!header.colorCondition && !header.conditionOn">
                                <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                  <ng-container *ngIf="(header.showIcon)">
                                    <em class="breakingnews icon-breaking" *ngIf='(item.metadata.breakingNews)'></em>
                                    <em class="sponsored icon-Combined-Shape" *ngIf='(item.metadata.sponsored)'></em>
                                  </ng-container>
                                  <!-- <ng-container *ngIf="(header.lockpage && item.lockedByUserId)">
                                    <em class="lockedIcon icon-lock">
                                      <div class="arrow_box single">{{item.lockedByUserId}}</div>
                                    </em>
                                  </ng-container> -->
                                  <div class="relhidden">
                                    <div class="listCell" title="{{dataValue !== '-'? dataValue.trim() :'-'}}">{{dataValue
                                      | titlecase}}</div>
                                  </div>
                                </li>
                              </ng-container>
                              <ng-container *ngIf="!header.colorCondition && header.conditionOn">
                                <li [class]="header.class">
                                  <small [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                    <div class="relhidden">
                                      <div class="listCell" [innerHTML]="dataValue"></div>
                                    </div>
                                  </small>
                                </li>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'url'">

                              <li [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ? htmlToPlaintext(dataValue):''">
                                <div class="relhidden">
                                  <div class="listCell" title="{{dataValue !== '-'? dataValue.trim() :'-'}}">{{dataValue}}</div>
                                </div>
                              </li>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'date'">
                              <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-' }}</li>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </a>
                      <div [class]="toggleArry.indexOf(item.id) > -1 ? 'revertStoryBlock pagenavdrop active' : 'revertStoryBlock pagenavdrop'" id="page_{{item.id}}" *ngIf="page_id.indexOf('page') > -1">
                        <ul>
                          <li><a href="/dash/page/nav-manager/{{item.id}}">Top Nav</a></li>

                          <li *ngIf="showSubNav()"><a href="/dash/page/sub-nav-manager/{{item.id}}">Sub Nav</a></li>
                          <li><a href="/dash/page/{{item.id}}">Manage</a></li>
                        </ul>
                      </div>
                      <li *ngIf="page_id.indexOf('page') > -1" class="relative pagemoredot" (click)="showNav(item.id)">
                        <span class="threedots"><span></span><span></span><span></span></span>
                      </li>
                    </ul>
                  </div>
                </ng-container>
                <ng-container *ngIf="page_id.indexOf('wire') > -1">
                  <!-- <div class="wire-story-preview" #wireRef
                    [storyId]="item.id" [data]="item" pageId="wires" allApi="one_story" [headers]="headerList"
                    (sendPreviewId)="setFocusListItem($event)"
                    [byAgencyIn]="byAgencyWire ? byAgencyWire : null"></div> -->

                  <ul #listEl tabindex="0" [class]="(checkFocusInside(listEl)) ? 'locked rssfeedul  focused' : 'locked rssfeedul'"
                    [class.active]="!item.lockedByUser" (keydown)="openPreviewIfFocused($event, listEl, item)">
                    <ng-container *ngFor="let header of headerList; trackBy: trackByName">
                      <ng-container *ngIf="getValuefromObject(item,header.model_id); let dataValue">
                        <!-- <p>{{dataValue}}</p> -->
                        <ng-container *ngIf="header.type == 'text'">
                          <ng-container *ngIf="header.conditionOn && item[header.conditionOn];then withIcon else withoutIcon">
                          </ng-container>
                          <ng-template #withIcon>
                            <li (click)="openPreview(item)" [class]="header.class + ' spImg'" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                              <div class="relhidden">
                                <div class="listCell">{{dataValue ? dataValue : ''}}</div>
                              </div>
                            </li>
                          </ng-template>
                          <ng-template #withoutIcon>
                            <ng-container *ngIf="header.colorCondition">
                              <li (click)="openPreview(item)" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                                <span class={{dataValue.toLowerCase()}}>
                                  {{dataValue}}
                                </span>
                              </li>
                            </ng-container>

                            <ng-container *ngIf="!header.colorCondition">
                              <li (click)="openPreview(item)" [class]="header.class" [title]="dataValue && (dataValue.trim().length > 30) ?dataValue:''">
                                <div class="relhidden">
                                  <div class="listCell">{{dataValue ? dataValue : ''}}</div>
                                </div>
                              </li>
                            </ng-container>
                          </ng-template>
                        </ng-container>

                        <ng-container *ngIf="header.type == 'date'">
                          <li (click)="openPreview(item)" [class]="header.class">
                            <div class="relhidden">
                              <div class="listCell">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</div>
                            </div>
                          </li>
                        </ng-container>


                        <ng-container *ngIf="header.type == 'date_day'">
                          <li (click)="openPreview(item)" [class]="header.class">
                            <div class="relhidden">
                              <div class="listCell">{{dataValue !== '-'?getNewTypeDateDay(dataValue):'-'}}</div>
                            </div>
                          </li>
                        </ng-container>

                        <ng-container *ngIf="header.type == 'component' && header.header_id == 'pickUp'">
                          <li class="pickUp">
                          <!-- <span class="pickStory icon-translate" *ngIf="type3">
                              <div class="arrow_box multiple">
                                <ul>
                                  <li>Select Language</li>
                                  <li *ngFor="let language of targetLaguages" (click)="openStoryEdit(item, language.id)">{{language.name}}</li>
                                </ul>
                              </div>
                            </span> -->
                            <ng-container *ngIf="type3">
                                <span class="pickStory icon-pickup"
                                *ngFor="let language of targetLaguages"
                                  (click)="openStoryEdit(item, language.id)"  >
      
                                </span>
                              </ng-container>
      
                            <ng-container *ngIf="type2">
                            <span class="pickStory icon-pickup"
                            *ngFor="let language of targetLaguages"
                              (click)="openStoryEdit(item, language.id)"  >

                            </span>
                          </ng-container>
                            <ng-container  *ngIf="type1">
                            <span class="pickStory icon-pickup" *ngFor="let language of targetLaguages"
                              (click)="openStoryEdit(item, language.id)" >
                            <div class="arrow_box single">Pick as Story</div></span>
                            </ng-container>

                            <!-- pickLink green icon-link -->

                              <span [class]="'pickLink' + (checkIfOnePublished(item) ? ' green' : '') + ' icon-link'"
                              *ngIf="item.wirePublishedStories && item.wirePublishedStories.length > 0 && checkDomain(item)">
                                <!-- {{item ? item.agency : 'temporary'}} -->
                                <ng-container *ngIf="item.wirePublishedStories.length > 1">
                                  <div class="arrow_box multiple">
                                    <ng-container *ngFor="let pickedStory of item.wirePublishedStories">
                                      <ng-container *ngIf="pickedStory">
                                        <ul>
                                          <li (click)="open_new(pickedStory.id)" *ngIf="pickedStory.domainId == domain"  >
                                            <div [class]="((pickedStory.metadata && pickedStory.metadata.status && pickedStory.metadata.status === 'PUBLISHED') ? 'storyline published' : 'storyline')">
                                              {{pickedStory.title ? pickedStory.title : ''}}</div>
                                            <div class="writername">{{(pickedStory.metadata != null &&
                                              pickedStory.metadata.authors != null && pickedStory.metadata.authors.length >
                                              0) ?
                                              pickedStory.metadata.authors[0]
                                              : '-'}}</div>
                                          </li>
                                        </ul>
                                      </ng-container>
                                    </ng-container>
                                  </div>
                                </ng-container>
                                <ng-container *ngIf="item.wirePublishedStories.length === 1">
                                  <div class="arrow_box single" *ngIf="item.wirePublishedStories[0].domainId == domain">{{item.wirePublishedStories[0].title ?
                                    item.wirePublishedStories[0].title : ''}}</div>
                                </ng-container>
                              </span>

                          </li>
                        </ng-container>
                        <ng-container *ngIf="header.type == 'component' && header.header_id == 'pickURL'">
                            <li class="pickUp"><span class="pickLink icon-link" (click)="openUrl(dataValue)"></span>
                        </li>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </ul>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
        </div>
      </ng-template>

      <ng-template #showphotoListing>
      <!--  <ng-container *ngIf="byThumbnail;then showphotosDetail else showPhotos"> </ng-container> -->
      <!--   <ng-template #showphotosDetail> -->

      
          
          <div class="internaldisplayView fl100" *ngIf="page_id === 'photoListing'">
              <h3>Recently Used</h3> {{amazonAffiliatePhotoListing}}
                <ul class="tabdisplay">
                  <ng-container *ngIf="lowQualityFilterButton">
               <label> <h6>Low Quality(Based on Size)</h6></label>
                <label class="switch toggle" tabindex="0">
                  <input
                    type="checkbox"
                    (click)="toggleSwitch('lowQuality')"/>
                  <span class="slider round"></span>
                </label>
              </ng-container>
               <label> <h6>High Quality(Based on AusScore)</h6></label>
                <label class="switch toggle" tabindex="0">
                  <input
                    type="checkbox"
                    (click)="toggleSwitch('AusScore')"/>
                  <span class="slider round"></span>
                </label>
                <ng-container *ngIf="isPrintImagesEnabled">
                <label><h6>Print Images</h6></label>
                <label class="switch toggle" tabindex="0">
                  <input
                    type="checkbox"
                    (click)="toggleSwitch('imageType')"/>
                  <span class="slider round"></span>
                </label>
                </ng-container>
                <label><h6>More than 1000px width</h6></label>
                <label class="switch toggle" tabindex="0">
                  <input
                    type="checkbox"
                    (click)="toggleSwitch('width')"/>
                  <span class="slider round"></span>
                </label>
                <li [class.active]="selectedView == 'gridView'" (click)="toggleView('gridView')"><i class="icon-grid"></i></li>
                <li [class.active]="selectedView == 'listView'" (click)="toggleView('listView')"><i class="icon-list" id="listViewIcon"></i> </li>
              </ul>
            </div>
          <div class="imagespopup" *ngIf="selectedView === 'listView'">
            <div class="listdetail">
              <ul class="headingList">
                <ng-container *ngFor="let header of headerList">
                  <li [class]="header.class"> {{header.name}}</li>
                </ng-container>
              </ul>
              <div class="contentList">
                <ng-template #loading>
                  <div style="text-align: center; display: inline-block; width: 100%">
                    <ng-container *ngIf="callFail">
                      <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                        Sorry, Server Error
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!callFail">
                      <div class="imagepreloader">
                        <div class="a" style="--n: 5;">
                          <div class="dot dot1" style="--i: 0;"></div>
                          <div class="dot dot2" style="--i: 1;"></div>
                          <div class="dot dot3" style="--i: 2;"></div>
                          <div class="dot dot4" style="--i: 3;"></div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>

                <ng-template #nores>
                  <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
                </ng-template>
              <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
              <ng-template #listData>
                
                <ng-container *ngIf="listArray.length > 0;else loading">
                  <div class="search-results" id="imagesListOnInternalTabBlockListView" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                    [scrollWindow]="false" (scrolled)="fetchMore()">
                    <ng-container *ngFor="let item of listArray; trackBy: trackByName; let i = index">
                      <ul [class]="(0 > exclusionListArray.indexOf(item.id)) ? 'list': 'list diableImage'">
                        <ng-container *ngFor="let header of headerList; trackBy: trackByName; let j = index">
                          <a (click)="(!showPhotoGalleryListing || (0 > exclusionListArray.indexOf(item.id))) ? sendImageToParent(item,'story') : false">
                            <ng-container *ngIf="header.type !== 'list'">
                              <ng-container *ngIf="getValuefromObject(item,header.model_id); let dataValue">
                                <ng-container *ngIf="header.type == 'image'">
                                  <li [class]="header.class">
                                    <img [src]="(dataValue !== '-') ? dataValue : ((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, '960x540') : '')"
                                      alt=" ">
                                  </li>
                                </ng-container>
                                <ng-container *ngIf="header.type == 'text'">
                                  <li [class]="header.class">{{dataValue}}</li>
                                </ng-container>
                                <ng-container *ngIf="header.type == 'date'">
                                  <li [class]="header.class">{{dataValue !== '-'?getNewTypeDate(dataValue):'-'}}</li>
                                </ng-container>
                              </ng-container>
                            </ng-container>
                            <ng-container *ngIf="header.type == 'list'">
                              <li [class]="header.class">
                                <ul class="tags" *ngIf="item.metadata">
                                  <ng-container *ngFor="let tags of item.metadata.tags; let k = index">
                                    <li *ngIf="k<2">{{tags}}</li>
                                  </ng-container>
                                </ul>
                              </li>
                            </ng-container>
                          </a>
                          <ng-container *ngIf="header.type == 'action'">
                            <li [class]="header.class">
                              <span class="viewEye" (click)="showimagePreview(i,true)">
                                <i class="icon-view-image"></i>                                
                              </span>
                              <span class="viewEye" *ngIf="!showPhotoGalleryListing && getImageDownloadFlag() && !getDownloadImageManagerFlag()" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)">
                                <i class="icon-select"></i>
                              </span>
                              <span class="viewEye" *ngIf="getDownloadImageManagerFlag()" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)">
                                <i class="icon-select"></i>
                              </span>
                              <span class="edit" id="p_{{item.id}}" (click)="pusharrayImage(item,'story')" *ngIf="showPhotoGalleryListing && (0 > exclusionListArray.indexOf(item.id))">
                                <i class="icon-checkbox-tick"></i>
                              </span>

                              <div [ngClass]="lightBoxP == i && (viewPhoto)  ? 'lightBox block' : lightBoxP == i && (viewPhoto == 'false') ? 'lightBox' : 'lightBox'"
                                *ngIf="(viewPhoto)">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="showimagePreview(i,false)"></div>
                                </div>
                                <div class="lightContent">
                                  <div class="detialimageViw">
                                    <div class="imagesPart">
                                      <img [src]="(item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null"
                                        alt="">
                                    </div>
                                    <div class="imageContent">
                                      <h3>{{item.credit ? item.credit : (item.metadata && item.metadata.agency ?
                                        item.metadata.agency : '')}}</h3>
                                      <label>caption</label>
                                      <p [innerHTML]="item.image ? item.image.caption: ''"></p>
                                      <label>Created On</label>
                                      <p>
                                        {{item['createdDate'] !== '-'?getNewTypeDate(item['createdDate']):'-'}}
                                      </p>
                                      <label>Created by</label>
                                      <p>Abhinav Lokesh</p>
                                      <div class="phtototags">
                                        <label>Tags</label>
                                        <ul *ngIf="item.metadata">
                                          <li *ngFor="let tags of item.metadata.tags; let j = index"> {{tags}} </li>
                                        </ul>
                                      </div>
                                      <div class="width100 fl btnBlock" *ngIf="!getDownloadImageManagerFlag()">
                                        <!-- <button type="button" name="createCard" class="createCard yellow">Use Raw</button> -->
                                        <button type="button" name="createStory" class="createStory blue" *ngIf="(0 > exclusionListArray.indexOf(item.id))"
                                          (click)="sendImageToParent(item,'story')">Use Image 
                                        </button>
                                        <button *ngIf="getImageDownloadFlag()" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </div>
                                      <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()">
                                        <button (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              </div>
                              <div class="bigIImage">
                                <img class="relative" width="100%" [src]="((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, '960x540') : '')"
                                  alt="">
                              </div>
                            </li>
                          </ng-container>
                        </ng-container>
                      </ul>
                    </ng-container>
                  </div>
                </ng-container>
                </ng-template>
              </div>
            </div>
            <div class="right choosephotos fl100" *ngIf="showPhotoGalleryListing">
              <button type="button" name="discard" class="discard gray" (click)="unselectAll()">Unselect All</button>
              <button type="button" name="save" class="save blue" (click)="pushImageList()">Choose
                {{this.listImageArrayC.length}}
                Images
              </button>
            </div>
          </div>

          <div *ngIf="selectedView === 'gridView'">
            <ng-template #loading>
              <div style="text-align: center; display: inline-block; width: 100%">
                <ng-container *ngIf="callFail">
                  <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
                    Sorry, Server Error
                  </div>
                </ng-container>
                <ng-container *ngIf="!callFail">
                  <div class="imagepreloader">
                    <div class="a" style="--n: 5;">
                      <div class="dot dot1" style="--i: 0;"></div>
                      <div class="dot dot2" style="--i: 1;"></div>
                      <div class="dot dot3" style="--i: 2;"></div>
                      <div class="dot dot4" style="--i: 3;"></div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </ng-template>
            <ng-container *ngIf="byWireThumbnail;then wirePhoto else storythumbPhoto">

            </ng-container>
            <ng-template #wirePhoto>
              <ng-template #nores>

                <div class="imagespopup">
                  <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
                </div>
              </ng-template>
              <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
              <ng-template #listData>
                <ng-container *ngIf="listArray.length > 0;else loading">

                  <div class="imagespopup">
                    <ul class="imagelist search-results" id="imagesListOnInternalTabBlock" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                    [scrollWindow]="false" (scrolled)="fetchMore()">
                      <!-- <ngx-masonry>
                    <ngxMasonryItem class="masonry-item" *ngFor="let item of listArray;let i = index">                -->
                      <div class="">
                        <li *ngFor="let item of listArray;let i = index">
                          <div class="imageblock">
                            <div class="image" (mouseenter)="onHovering($event)">
                              <div class="imagecontain">
                                <img *ngIf="page_id !=='mobile91Listing'" src="{{wireImageDisplayUrl}}{{item?.location}}/{{item?.thumbnailImageName}}" alt="">
                                <img *ngIf="page_id ==='mobile91Listing'" src="{{mobile91DisplayUrl}}{{item?.url}}" alt="">

                                <ng-container *ngIf="showPhotoGalleryListing;then showCheck else hideCheck"></ng-container>
                                <ng-template #hideCheck>
                                  <span class="hover" *ngIf="!getDownloadImageManagerFlag()">
                                    <button *ngIf="page_id !=='mobile91Listing'" class="blue" (click)="sendImageToParent(item,'wire')">Use Image</button>
                                    <button *ngIf="page_id ==='mobile91Listing'" class="blue" (click)="sendImageToParent(item,'mobile91')">Use Image</button>
                                    <button *ngIf="page_id !=='mobile91Listing' && getImageDownloadFlag()" (click)="downloadImage((item.location !== null && item.fileName !== null) ? (wireImageDisplayUrl + item.location + '/' + item.fileName) : null)" type="button" class="createStory blue" container="body">Download</button>
                                    <button *ngIf="page_id ==='mobile91Listing' && getImageDownloadFlag()" (click)="downloadImage((item.url !== null) ? (mobile91DisplayUrl + item.url) : null)" type="button" class="createStory blue" container="body">Download</button>
                                  </span>
                                  <span class="hover" *ngIf="page_id !=='mobile91Listing' && getDownloadImageManagerFlag()">
                                    <button (click)="downloadImage((item.location !== null && item.fileName !== null) ? (wireImageDisplayUrl + item.location + '/' + item.fileName) : null)" type="button" class="createStory blue" container="body">Download</button>
                                  </span>
                                  <span class="hover" *ngIf="page_id ==='mobile91Listing' && getDownloadImageManagerFlag()">
                                    <button (click)="downloadImage((item.url !== null) ? (mobile91DisplayUrl + item.url) : null)" type="button" class="createStory blue" container="body">Download</button>
                                  </span>
                                </ng-template>
                                <ng-template #showCheck>
                                  <span class="hover" *ngIf="page_id !=='mobile91Listing'"(click)="pusharrayImage(item,'wire')">
                                    <button class="blue spImg_story" class="blue" id="{{item.id}}">
                                      <i class="icon-checkbox-tick"></i>
                                    </button>
                                  </span>
                                  <span class="hover" *ngIf="page_id ==='mobile91Listing'"(click)="pusharrayImage(item,'mobile91')">
                                    <button class="blue spImg_story" class="blue" id="{{item.id}}">
                                      <i class="icon-checkbox-tick"></i>
                                    </button>
                                  </span>
                                </ng-template>

                              </div>
                              <div class="imageDetail" *ngIf="!showPhotoGalleryListing">
                                <div class="relative">
                                  <label>Caption</label>
                                  <p [innerHTML]="item.caption ? item.caption: ''"></p>
                                  <label>Created On</label>
                                  <p>{{getNewTypeDate(item.timestamp)}}</p>
                                  <!-- <label>Tags</label>
                                  <ul class="tags">
                                    <ng-container *ngFor="let tags of item.metadata?.tags; let j = index">
                                      <li *ngIf="j<2">{{tags}}</li>
                                    </ng-container>
                                  </ul> -->
                                </div>
                              </div>
                            </div>
                            <div class="imageInfo">
                              <span [innerHTML]="item.caption ? (item.caption.trim().substr(0,30) + '...') : ''"></span>
                              <span class="viewEye" (click)="showimagePreview(i,true)">
                                <i class="icon-view-image"></i>
                              </span>
                              <div [ngClass]="lightBoxP == i && (viewPhoto)  ? 'lightBox block' : lightBoxP == i && (viewPhoto == 'false') ? 'lightBox' : 'lightBox'"
                                *ngIf="(viewPhoto)">
                                <div class="headerLight">
                                  <div class="close fl spImg" (click)="showimagePreview(i,false)"></div>
                                </div>
                                <div class="lightContent">
                                  <div class="detialimageViw">
                                    <div *ngIf="page_id !=='mobile91Listing'" class="imagesPart">
                                      <img src="{{wireImageDisplayUrl}}{{item?.location}}/{{item?.fileName}}" alt="">
                                    </div>
                                    <div *ngIf="page_id ==='mobile91Listing'" class="imagesPart">
                                      <img src="{{mobile91DisplayUrl}}{{item?.url}}" alt="">
                                    </div>
                                    <div class="imageContent">
                                      <h3>{{item.credit ? item.credit : (item.metadata && item.metadata.agency ?
                                        item.metadata.agency : '')}}</h3>
                                      <label>caption</label>
                                      <p [innerHTML]="item.caption ? item.caption: ''"></p>
                                      <label>Created On</label>

                                      <p>
                                        {{getNewTypeDate(item.timestamp)}}
                                      </p>
                                      <!-- <label>Created by</label>
                                      <p>Abhinav Lokesh</p>
                                      <div class="phtototags">
                                        <label>Tags</label>
                                        <ul>
                                          <li *ngFor="let tags of item.metadata?.tags; let j = index"> {{tags}} </li>
                                        </ul>
                                      </div> -->
                                      <div class="width100 fl btnBlock" *ngIf="!getDownloadImageManagerFlag()">
                                        <!-- <button type="button" name="createCard" class="createCard yellow">Use Raw</button> -->
                                        <button type="button" name="createStory" class="createStory blue" (click)="sendImageToParent(item,'wire')"
                                          *ngIf="page_id !=='mobile91Listing' && !showPhotoGalleryListing">Use Image</button>
                                        <button type="button" name="createStory" class="createStory blue" (click)="sendImageToParent(item,'mobile91')"
                                          *ngIf="page_id ==='mobile91Listing' && !showPhotoGalleryListing">Use Image</button>
                                          <button *ngIf="page_id !=='mobile91Listing' && getImageDownloadFlag()" (click)="downloadImage((item.location !== null && item.fileName !== null) ? (wireImageDisplayUrl + item.location + '/' + item.fileName) : null)" type="button" class="createStory blue" container="body">Download</button>
                                          <button *ngIf="page_id ==='mobile91Listing' && getImageDownloadFlag()" (click)="downloadImage((item.url !== null) ? (mobile91DisplayUrl + item.url) : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </div>
                                      <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()">
                                          <button (click)="downloadImage((item.location !== null && item.fileName !== null) ? (wireImageDisplayUrl + item.location + '/' + item.fileName) : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </div>
                                      <!-- 
                                      <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()">
                                        <button (click)="downloadImage((item.url) ? (mobile91DisplayUrl + item.url) : null)" type="button" class="createStory blue" container="body">Download</button>
                                    </div> -->
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                      <!-- </ngxMasonryItem>
            </ngx-masonry> -->
                    </ul>
                    <div class="right choosephotos fl100" *ngIf="showPhotoGalleryListing">
                      <button type="button" name="discard" class="discard gray" (click)="unselectAll()">Unselect All</button>
                      <button type="button" name="save" class="save blue" (click)="pushImageList()">Choose
                        {{this.listImageArrayC.length}} Images</button>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </ng-template>

            <ng-template #storythumbPhoto>
              
              <ng-container *ngIf="page_id == 'slideVideoListing'">
                <ng-template #nores>

                  <div class="imagespopup">
                    <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
                  </div>
                </ng-template>
                <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
                <ng-template #listData>
      
                  <div class="imagespopup">
                    <ng-container *ngIf="listArray.length > 0;else loading">
                      <ul class="imagelist search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                      [scrollWindow]="false" (scrolled)="fetchMore()">
                        <!-- <ngx-masonry>
                      <ngxMasonryItem class="masonry-item" *ngFor="let item of listArray;let i = index"> -->
      
                          <ng-container *ngFor="let item of listArray;let i = index">
                            <li [class]="(exclusionListArray.indexOf(item.id) > -1) ? 'diableImage' : ''">
                              <div class="imageblock">
                                <div class="image" (mouseenter)="onHovering($event)">
                                  <div class="imagecontain">
                                    <video [src]="item?.video?.url"
                                      (click)="(0 > exclusionListArray.indexOf(item.id)) ? pusharrayImage(item,'story') : false"></video>
      
                                    <ng-container *ngIf="showPhotoGalleryListing;then showCheck else hideCheck"></ng-container>
                                    <ng-template #hideCheck>
                                      <span class="hover" *ngIf="!getDownloadImageManagerFlag()">
                                        <button class="blue" (click)="(0 > exclusionListArray.indexOf(item.id)) ? sendImageToParent(item,'story'): false">Use
                                          video</button>
                                          <!--button *ngIf="getImageDownloadFlag()" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button-->
                                      </span>
                                      <span class="hover" *ngIf="getDownloadImageManagerFlag()">
                                          <button (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </span>
                                    </ng-template>
                                    <ng-template #showCheck>
                                      <span class="hover" (click)="(0 > exclusionListArray.indexOf(item.id)) ? pusharrayImage(item,'story'): false">
                                        <button class="blue" id="{{item.id}}">
                                          <i class="icon-checkbox-tick"></i>
                                        </button>
                                      </span>
                                    </ng-template>
      
                                  </div>
                                  <div class="imageDetail" *ngIf="!showPhotoGalleryListing">
                                    <div class="relative">
                                      <label>Caption</label>
                                      <p [innerHTML]="(item.image && item.image.caption) ? item.image.caption.trim() : ''"></p>
                                      <label>Created On</label>
                                      <p>{{getNewTypeDate(item['createdDate'])}}</p>
                                      <label>Tags</label>
                                      <ul class="tags" *ngIf="item.metadata">
                                        <ng-container *ngFor="let tags of item.metadata.tags; let j = index">
                                          <li *ngIf="j<2">{{tags}}</li>
                                        </ng-container>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <!--div class="imageInfo">
                                  <span [innerHTML]="(item.image && item.image.caption) ? (item.image.caption.trim().substr(0,30) + '...') : ''"></span>
                                  <span *ngIf="(0 > exclusionListArray.indexOf(item.id))" class="viewEye" (click)="showimagePreview(i,true)">
                                    <i class="icon-view-image"></i>
                                  </span>
                                  <div [ngClass]="lightBoxP == i && (viewPhoto)  ? 'lightBox block' : lightBoxP == i && (viewPhoto == 'false') ? 'lightBox' : 'lightBox'"
                                    *ngIf="(viewPhoto)">
                                    <div class="headerLight">
                                      <div class="close fl spImg" (click)="showimagePreview(i,false)"></div>
                                    </div>
                                    <div class="lightContent">
                                      <div class="detialimageViw">
                                        <div class="imagesPart">
                                          <img [src]="(item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null"
                                            alt="">
                                        </div>
                                        <div class="imageContent">
                                          <h3>{{item.credit ? item.credit : (item.metadata && item.metadata.agency ?
                                            item.metadata.agency : '')}}</h3>
                                          <label>caption</label>
                                          <p [innerHTML]="item.image && item.image.caption ? item.image.caption: ''"></p>
                                          <label>Created On</label>
      
                                          <p>
                                            {{item['createdDate'] !== '-'?getNewTypeDate(item['createdDate']):'-'}}
                                          </p>
                                          <label>Created by</label>
                                          <p>{{item['createdBy'] ? item['createdBy'] : '-'}}</p>
                                          <div class="phtototags">
                                            <label>Tags</label>
                                            <ul *ngIf="item.metadata">
                                              <li *ngFor="let tags of item.metadata.tags; let j = index"> {{tags}} </li>
                                            </ul>
                                          </div>
                                          <div class="width100 fl btnBlock" *ngIf="!getDownloadImageManagerFlag()">
                                            <button type="button" name="createStory" class="createStory blue" (click)="sendImageToParent(item,'story')"
                                              *ngIf="!showPhotoGalleryListing && (0 > exclusionListArray.indexOf(item.id))">Use
                                              Image </button> 
                                            <button *ngIf="getImageDownloadFlag() && !showPhotoGalleryListing" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                          </div>
                                          <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()"> 
                                            <button (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div-->
                              </div>
                            </li>
                          </ng-container>
      
                        <!-- </ngxMasonryItem>
                    </ngx-masonry> -->
                      </ul>
                      <div class="right choosephotos fl100" *ngIf="showPhotoGalleryListing">
                        <button type="button" name="discard" class="discard gray" (click)="unselectAll()">Unselect All</button>
                        <button type="button" id=" chooseButtonInImageGallery" name="save" class="save blue" (click)="pushImageList()">Choose
                          {{this.listImageArrayC.length}}
                          Images
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </ng-container>


              <ng-container *ngIf="page_id != 'slideVideoListing' && page_id !='pixabayListing'">
                <ng-template #nores>

                  <div class="imagespopup">
                    <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
                  </div>
                </ng-template>
                <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
                <ng-template #listData>
      
                  <div class="imagespopup">
                    <ng-container *ngIf="listArray.length > 0;else loading">
                      <ul class="imagelist search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                      [scrollWindow]="false" (scrolled)="fetchMore()">
                        <!-- <ngx-masonry>
                      <ngxMasonryItem class="masonry-item" *ngFor="let item of listArray;let i = index"> -->
      
                          <ng-container *ngFor="let item of listArray;let i = index">
                            <li [class]="(exclusionListArray.indexOf(item.id) > -1) ? 'diableImage' : ''">
                              <div class="imageblock">
                                <div class="image" (mouseenter)="onHovering($event)">
                                  <div class="imagecontain">
                                    <div><img [src]="((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, '250x250') : '')"
                                      (click)="(0 > exclusionListArray.indexOf(item.id)) ? pusharrayImage(item,'story') : false"
                                      alt="">
                                    </div>
                                    <div class="blackStip">
                                      <div *ngIf="item.image && item.image.images && item.image.images.resolution; else resolutionBlock" class="blk-left">{{item.image.images.resolution}}</div>
                                      <ng-template #resolutionBlock>
                                        <div *ngIf="item.image.width && item.image.height" class="blk-left">{{item.image.width}} * {{item.image.height}}</div>
                                      </ng-template>

                                      <div *ngIf="item.image && item.image.images && item.image.images.size;  else resolutionBlockforSize" class="blk-right">{{item.image.images.size}} KB</div>
                                      <ng-template #resolutionBlockforSize>
                                      <div *ngIf="item.image.size" class="blk-right">{{item.image.size}} KB</div>
                                      </ng-template>

                                      <div *ngIf="item.image.ausScore > minAusScore" class="blk-star"><img src="../../../assets/images/star2.png" width="20" height="20"></div>
                                      <div *ngIf="item.image && item.image.images && item.image.images.imageSource" class="blk-print">{{item.image.images.imageSource}}</div>
                                    </div>
                                    
            
                                    <ng-container *ngIf="showPhotoGalleryListing;then showCheck else hideCheck"></ng-container>
                                    <ng-template #hideCheck>
                                      <span class="hover" *ngIf="!getDownloadImageManagerFlag()">
                                        <button *ngIf="!domainWiseImageList" class="blue" (click)="(0 > exclusionListArray.indexOf(item.id)) ? sendImageToParent(item,'story'): false">Use Image</button>
                                        <button *ngIf="domainWiseImageList" class="blue" (click)="(0 > exclusionListArray.indexOf(item.id)) ? sendImageToParent(item,'crossTenant'): false">Use Image</button>
                                          <button *ngIf="getImageDownloadFlag()" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </span>
                                      <span class="hover" *ngIf="getDownloadImageManagerFlag()">
                                          <button (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </span>
                                    </ng-template>
                                    <ng-template #showCheck>
                                      <span class="hover" (click)="(0 > exclusionListArray.indexOf(item.id)) ? pusharrayImage(item,'story'): false">
                                        <button class="blue" id="{{item.id}}">
                                          <i class="icon-checkbox-tick"></i>
                                        </button>
                                      </span>
                                    </ng-template>
      
                                  </div>
                                  <div class="imageDetail" *ngIf="!showPhotoGalleryListing">
                                    <div class="relative">
                                      <label>Caption</label>
                                      <p [innerHTML]="(item.image && item.image.caption) ? item.image.caption.trim() : ''"></p>
                                      <label>Created On</label>
                                      <p>{{getNewTypeDate(item['createdDate'])}}</p>
                                      <label>Tags</label>
                                      <ul class="tags" *ngIf="item.metadata">
                                        <ng-container *ngFor="let tags of item.metadata.tags; let j = index">
                                          <li *ngIf="j<2">{{tags}}</li>
                                        </ng-container>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div class="imageInfo">
                                  <span [innerHTML]="(item.image && item.image.caption) ? (item.image.caption.trim().substr(0,30) + '...') : ''"></span>
                                  <span *ngIf="(0 > exclusionListArray.indexOf(item.id))" class="viewEye" (click)="showimagePreview(i,true)">
                                    <i class="icon-view-image"></i>
                                  </span>
                                  <div [ngClass]="lightBoxP == i && (viewPhoto)  ? 'lightBox block' : lightBoxP == i && (viewPhoto == 'false') ? 'lightBox' : 'lightBox'"
                                    *ngIf="(viewPhoto)">
                                    <div class="headerLight">
                                      <div class="close fl spImg" (click)="showimagePreview(i,false)"></div>
                                    </div>
                                    <div class="lightContent">
                                      <div class="detialimageViw">
                                        <div class="imagesPart">
                                          <img [src]="(item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null"
                                            alt="">
                                        </div>
                                        <div class="imageContent">
                                          <h3>{{item.credit ? item.credit : (item.metadata && item.metadata.agency ?
                                            item.metadata.agency : '')}}</h3>
                                          <label>caption</label>
                                          <p [innerHTML]="item.image && item.image.caption ? item.image.caption: ''"></p>
                                          <label>Created On</label>
      
                                          <p>
                                            {{item['createdDate'] !== '-'?getNewTypeDate(item['createdDate']):'-'}}
                                          </p>
                                          <label>Created by</label>
                                          <p>{{item['createdBy'] ? item['createdBy'] : '-'}}</p>
                                          <div class="phtototags">
                                            <label>Tags</label>
                                            <ul *ngIf="item.metadata">
                                              <li *ngFor="let tags of item.metadata.tags; let j = index"> {{tags}} </li>
                                            </ul>
                                          </div>
                                          <div class="width100 fl btnBlock" *ngIf="!getDownloadImageManagerFlag()">
                                            <!-- <button type="button" name="createCard" class="createCard yellow">Use Raw</button> -->
                                            <button type="button" name="createStory" class="createStory blue" (click)="sendImageToParent(item,'story')"
                                              *ngIf="!showPhotoGalleryListing && (0 > exclusionListArray.indexOf(item.id))">Use Image</button> 
                                            <button *ngIf="getImageDownloadFlag() && !showPhotoGalleryListing" (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                          </div>
                                          <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()"> 
                                            <button (click)="downloadImage((item.image !== null && item.image.images !== null) ? sharedService.getImageOnPriority(item.image.images, 'original') : null)" type="button" class="createStory blue" container="body">Download</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ng-container>
      
                        <!-- </ngxMasonryItem>
                    </ngx-masonry> -->
                      </ul>
                      <div class="right choosephotos fl100" *ngIf="showPhotoGalleryListing">
                        <button type="button" name="discard" class="discard gray" (click)="unselectAll()">Unselect All</button>
                        <button type="button" id=" chooseButtonInImageGallery" name="save" class="save blue" (click)="pushImageList()">Choose
                          {{this.listImageArrayC.length}}
                          Images
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="page_id === 'pixabayListing'">
                <ng-template #nores>
                  <div class="imagespopup">
                    <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">No Data</div>
                  </div>
                </ng-template>
                <ng-container *ngIf="noresults == false;then listData else nores"></ng-container>
                <ng-template #listData>
                  <div class="imagespopup">
                    <ng-container *ngIf="listArray.length > 0;else loading">
                      <ul class="imagelist search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
                      [scrollWindow]="false" (scrolled)="fetchMore()">     
                          <ng-container *ngFor="let item of listArray;let i = index">
                            <li >
                              <div class="imageblock">
                                <div class="image" (mouseenter)="onHovering($event)">
                                  <div class="imagecontain">
                                    <div><img [src]="item.largeImageURL" alt="">
                                    </div>
                                    <div class="blackStip">
                                      <div *ngIf="item.imageWidth" class="blk-left">{{item.imageWidth}}*{{item.imageHeight}}</div>
                                      <div *ngIf="item.imageSize" class="blk-right">{{formatSize(item.imageSize)}}</div>
                                    </div>
                                    <ng-container *ngIf="showPhotoGalleryListing;then showCheck else hideCheck"></ng-container>
                                    <ng-template #hideCheck>
                                      <span class="hover" *ngIf="!getDownloadImageManagerFlag()">
                                        <button class="blue" (click)="sendImageToParent(item,'pixabay')">Use Image</button>
                                      </span>
                                      <span class="hover" *ngIf="getDownloadImageManagerFlag()">
                                          <button (click)="downloadPixabayImage(item.largeImageURL !== null ? item.largeImageURL : null)" type="button" class="createStory blue" container="body">Download</button>
                                      </span>
                                    </ng-template>
                                    <ng-template #showCheck>
                                      <span class="hover" (click)="pusharrayImage(item,'pixabay')">
                                        <button class="blue" id="{{item.id}}">
                                          <i class="icon-checkbox-tick"></i>
                                        </button>
                                      </span>
                                    </ng-template>
      
                                  </div>
                                  <div class="imageDetail" *ngIf="!showPhotoGalleryListing">
                                    <div class="relative">
                                      <label>User</label>
                                      <p>{{item.user}}</p>
                                      <label>Tags</label>
                                      <p>{{item.tags}}</p>
                                    </div>
                                  </div>
                                </div>
                                <div class="imageInfo">
                                  <span  class="viewEye" (click)="showimagePreview(i,true)">
                                    <i class="icon-view-image"></i>
                                  </span>
                                  <div [ngClass]="lightBoxP == i && (viewPhoto)  ? 'lightBox block' : lightBoxP == i && (viewPhoto == 'false') ? 'lightBox' : 'lightBox'"
                                    *ngIf="(viewPhoto)">
                                    <div class="headerLight">
                                      <div class="close fl spImg" (click)="showimagePreview(i,false)"></div>
                                    </div>
                                    <div class="lightContent">
                                      <div class="detialimageViw">
                                        <div class="imagesPart">
                                          <img [src]="item.largeImageURL" alt="">
                                        </div>
                                        <div class="imageContent">
                                          <label>User</label>
                                          <p>{{item.user}}</p>
                                        
                                          <div class="phtototags">
                                            <label>Tags</label>
                                            <p>{{item.tags}}</p>
                                          </div>
                                          <div class="width100 fl btnBlock" *ngIf="getDownloadImageManagerFlag()"> 
                                            <button (click)="downloadPixabayImage(item.largeImageURL !== null ? item.largeImageURL : null)"  type="button" class="createStory blue" container="body">Download</button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ng-container>
      
              
                      </ul>
                      <div class="right choosephotos fl100" *ngIf="showPhotoGalleryListing">
                        <button type="button" name="discard" class="discard gray" (click)="unselectAll()">Unselect All</button>
                        <button type="button" id=" chooseButtonInImageGallery" name="save" class="save blue" (click)="pushImageList()">Choose
                          {{this.listImageArrayC.length}}
                          Images
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </ng-template>
              </ng-container>

            </ng-template>
        <!--  </ng-template> -->
          </div>
      </ng-template>
  </ng-container>
  </ng-container>

  <!-- video story listing -->
  <div *ngIf="isVideoStory">
    <ng-template #loading>
      <div style="text-align: center; display: inline-block; width: 100%;position: absolute; top: 65%; left: 10%;">
        <ng-container *ngIf="callFail">
          <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px;">
            Sorry, Server Error
          </div>
        </ng-container>
        <ng-container *ngIf="!callFail">
          <div class="imagepreloader">
            <div class="a" style="--n: 5;">
              <div class="dot dot1" style="--i: 0;"></div>
              <div class="dot dot2" style="--i: 1;"></div>
              <div class="dot dot3" style="--i: 2;"></div>
              <div class="dot dot4" style="--i: 3;"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #nores>
      <div style="text-align: center; display: inline-block; width: 100%; padding-top:200px; height: 100vh; border-top: 1px solid #ddd;">No Data</div>
    </ng-template>
    <ng-container *ngIf="((noresults == true) && (1 > videoList.length));then nores else listData"></ng-container>
    <ng-template #listData>

      <ng-container *ngIf="(page_id == 'videoServiceStory') && isVideoStory">
        <ng-container *ngIf="listArray.length > 0;else loading"></ng-container>
        <div class="videodisplayView">
          <ul class="viewdisplay">
            <li [class.active]="selectedItem == 'gridView'" (click)="setView('gridView')"><i class="icon-grid"></i></li>
            <li [class.active]="selectedItem == 'listView'" (click)="setView('listView')"><i class="icon-list" id="listViewIcon"></i> </li>
          </ul>
        </div>
        <div class="listgrid videoslist" *ngIf="selectedItem == 'gridView'">
          <div class="videoslistBlock">
            <ng-container *ngFor="let smallList of multiList">
              <ul class="videolist">
                <!-- <li *ngFor="let video of smallList" (deferLoad)="video.show = true"> -->
                <li *ngFor="let video of smallList">
                  <div class="imageblock">
                    <div class="image">
                      <!-- <ng-container *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images && video.show; then srcimageS else nosrcimageS"></ng-container> -->
                      <ng-container *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images; then srcimageS else nosrcimageS"></ng-container>
                      <ng-template #srcimageS>
                        <div class="imagecontain"><img [src]="sharedService.getImageOnPriority(video.leadMedia.image.images, '600x338')" alt=""></div>
                      </ng-template>
                      <ng-template #nosrcimageS>
                        <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt=""></div>
                      </ng-template>
                    </div>
                    <div class="imageInfo">
                      <div class="status"><span [class]="video.metadata.status">{{video.metadata.status}}</span></div>
                      <div class="heading"><a href="" [routerLink]="routeLinkForList !== 'false' && isVideoModal === false ? routeLinkForList + '/' + video.id : ''">{{video.title}}</a></div>
                      <div class="statusaction"><span class="date">{{getNewTypeDate(video.createdDate)}}</span>
                        <span class="actions fr">
                          <span class="edit"  [routerLink]="routeLinkForList !== 'false' ? routeLinkForList + '/' + video.id : ''" (click)="videoPickEvent((routeLinkForList !== 'false' ? routeLinkForList + '/' + video.id : ''))"><i class="icon-pickup"></i><div class="arrow_box single">Edit Story</div></span>
                          <span class="video_icon" (click)="openVideoModal(video, $event)"><i class="icon-play-regular"></i><div class="arrow_box single">Open Preview</div></span>
                        </span></div>
                    </div>
                  </div>
                </li>
              </ul>
            </ng-container>
          </div>
        </div>
        <div class="listdetail videosdetaillist" *ngIf="selectedItem == 'listView'">
          <div class="headingsList">
            <ul class="">
              <li class="video">Video</li>
              <li class="caption">Title</li>
              <li class="createdon">Created By</li>
              <li class="lastupdatedon">Last Updated On</li>
              <li class="updatedBy">Updated By</li>
              <li class="status">Status</li>
            </ul>
          </div>
          <div class="contentList">
            <div class="storyListing" *ngFor="let video of listArray; trackBy: trackByName; let i = index">
              <div class='story_status'>
                <em #unlockDropdown [class]="getclassonCondition(video.lockedByUserId,
                        page_id != 'pages' && video.metadata ? video.metadata.status : video.status)"
                  (click)="openOptions(i)">
                  <div class="arrow_box single" *ngIf="(video.lockedByUserId && unlockOptions !== i)">{{video.lockedByUserId}}</div>
                  <div class="revertStoryBlock" *ngIf="unlockOptions === i">
                    <ul *ngIf="video.type !== 'video'">
                      <li>
                        <button (click)="openUnlock(i)">Unlock</button>
                      </li>
                      <li>
                        <button (click)="copyUrl(i)">Copy Url</button>
                      </li>
                    </ul>
                    <ul *ngIf="video.type === 'video'">
                      <li *ngIf="video.lockedByUserId">
                        <button (click)="openUnlock(i)">Unlock</button>
                      </li>
                      <li>
                        <button (click)="copyUrl(i)">Copy Url</button>
                      </li>
                      <li>
                        <button id="Embed_btn" (click)="copyEmbed(clipboardInput)">Copy Embed</button>
                      </li>
                    </ul>
                  </div>
                </em>
                <em *ngIf="page_id != 'pages' && page_id != 'element'" [ngClass]="(video.metadata.markUnimportant)  ? 'notimportant icon-unimportant-active' : 'important icon-unimportant-inactive'"></em>
              </div>
              <ul class="list">
                <a #listEl tabindex="0" (click)="routeToLink(video.id)">
                  <li class="video">
                    <div class="imagecontain" *ngIf="video.leadMedia && video.leadMedia.image && video.leadMedia.image.images"><img
                        [src]="sharedService.getImageOnPriority(video.leadMedia.image.images, '600x338')" alt=""><i class="icon-play-regular"
                        (click)="openVideoModal(video, $event)"></i></div>
                    <div class="imagecontain" *ngIf="!video.leadMedia || !video.leadMedia.image || !video.leadMedia.image.images"><img
                        src="../../../assets/images/404.jpg" alt=""><i class="icon-play-regular" (click)="openVideoModal(video, $event)"></i></div>
                  </li>
                  <li class="caption">
                    <div class="relhidden">
                      <div class="listCell">{{video.title}}</div>
                    </div>
                  </li>
                  <li class="createdBy">
                    <div class="relhidden">
                      <div class="listCell">{{video.createdBy}}</div>
                    </div>
                  </li>
                  <li class="lastupdatedon">
                    <div class="relhidden">
                      <div class="listCell">{{getNewTypeDate(video.lastModifiedDate)}}</div>
                    </div>
                  </li>
                  <li class="updatedBy">
                    <div class="relhidden">
                      <div class="listCell">{{video.lastModifiedByUserName}}</div>
                    </div>
                  </li>
                  <li class="status">
                    <div class="listCell"><span [class]="video.metadata.status">{{video.metadata.status}}</span></div>
                  </li>
                </a>
              </ul>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="(page_id == 'videoStory' && isVideoStory)">
        <ng-container *ngIf="videoList.length > 0;else loading"></ng-container>
        <div class="listgrid videoslist">
          <div class="videoslistBlock">
            <ng-container *ngFor="let smallList of multiList">
              <ul class="videolist">
                  
                  <!-- <li *ngFor="let video of smallList" (deferLoad)="video.show = true"> -->
                  <li *ngFor="let video of smallList">
                  <div class="imageblock">
                    <div class="image" (mouseenter)="showVideoGalleryListing ? onHovering($event) : false">
                      <!-- <ng-container *ngIf="video.images && video.images.img_480 && video.show; then srcimage else nosrcimage"></ng-container> -->
                      <ng-container *ngIf="video.images && video.images.img_480; then srcimage else nosrcimage"></ng-container>
                      <ng-template #srcimage>
                        <div class="imagecontain"><img [src]="video.images.img_480" alt="">
                          <span class="hover" *ngIf="showVideoGalleryListing">
                              <button class="blue" (click)="sendVideoToParent(video)">Use
                                Video</button>
                            </span>
                        </div>
                      </ng-template>
                      <ng-template #nosrcimage>
                        <div class="imagecontain"><img src="../../../assets/images/404.jpg" alt="">
                          <span class="hover" *ngIf="showVideoGalleryListing">
                              <button class="blue" (click)="sendVideoToParent(video)">Use
                                Video</button>
                            </span>
                        </div>
                      </ng-template>
                    </div>
                    <div class="imageInfo">
                      <div class="status" *ngIf="page_id == 'videoServiceStory'"><span class="edited">Edited</span></div>
                      <div class="heading">{{video.name}}</div>
                      <div class="statusaction" *ngIf="!showVideoGalleryListing"><span class="date">{{getNewTypeDate(video.updated_at)}}</span>
                        <span class="actions fr">
                          <span class="edit" (click)="editVideo(video)"><i class="icon-pickup"></i><div class="arrow_box single">Pick as Story</div></span>
                          <span class="video_icon" (click)="openVideoModal(video, $event)"><i class="icon-play-regular"></i><div class="arrow_box single">Open Preview</div></span>
                        </span></div>
                    </div>
                  </div>
                  </li>
                
              
              </ul>
            </ng-container>
          </div>
        </div>
      </ng-container>


      



      <div class="viewVideoPreview lightBox block" *ngIf="openVideoPreview">
        <div class="headerLight">
          <div class="close fl spImg" (click)="closeVideoPreview()"></div>
        </div>
        <ng-container class="showVideoMessage" *ngIf="previewUrl == null">
          <div class="readstory block">
            <div class="unlockStory">
              <div class="wid100 pad30">
                <h1>Video does not exist...</h1>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="previewUrl !== null">
          <div class="lightContent">
            <div class="detialimageViw">
              <div _ngcontent-c6="" class="imagesPart">
                <iframe appIframeTracker #previewFrame [src]="previewUrl" [style]="iframeStyle" (load)="iframeLoaded($event)"></iframe>
              </div>
              <div class="imageContent">
                <h3> {{videDesc}}</h3>
                <label>Created in BrightCove on</label>
                <p>{{getNewTypeDate(videoCreated)}}</p>
                <label>Channel</label>
                <p>{{videoChannel}}</p>
                <div class="phtototags">
                  <label>Tags</label>
                  <ul>
                    <li *ngFor="let tag of tags"> {{tag}} </li>
                  </ul>
                </div>
                <div class="width100 fl btnBlock">
                  <button name="Insert Video" *ngIf="page_id === 'videoStory'" (click)="insertVideo()">Insert Video</button>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </div>
</ng-container>
</div>

<!-- footer pagination component -->
<div class="footerPagination" *ngIf="by_photoListing !== 'true' && showPagination">
  <div class="pagination" *ngIf="totalRecords > 50">Page
    <ul>
      <ng-container *ngIf="7 > pages">
        <ng-container *ngFor="let j of arrayOne(pages); let i = index">
          <!-- <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)"> -->
          <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
          <!-- </ng-container> -->
        </ng-container>
      </ng-container>
      <ng-container *ngIf="pages > 6">
        <ng-container *ngFor="let j of arrayOne(pages); let i = index">
          <ng-container *ngIf="i >= (pageNum - 3) && (pageNum + 3) > i && pages > (i+1)">
            <li [class]="pageNum == i ? 'active' : ''" (click)="onPageNumberChange(i)">{{(i + 1)}}</li>
          </ng-container>
        </ng-container>
        <li>..</li>
        <li [class]="pageNum == (pages-1) ? 'active' : ''" (click)="onPageNumberChange(pages - 1)">{{(pages)}}</li>
      </ng-container>
    </ul>
  </div>

  <ng-container *ngIf="totalRecords < 50;then displayPaging else showPaging"></ng-container>
  <ng-template #showPaging>
    <div *ngIf="!isCroma" class="recordList">Showing
      <ng-container *ngIf="page_id !='all_related_stories_embed'">

        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of pageSizeArray" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </ng-container>

      <ng-container *ngIf="page_id =='all_related_stories_embed'">

        <select name="recordList" class="select-wrapper" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
          <option *ngFor="let c of affiliateSizeArr" [ngValue]="c"> {{c}} </option>
        </select>results of {{totalRecords}}
      </ng-container>
    </div>
  </ng-template>
  <ng-template #displayPaging>
    <div class="recordList borderNone">
      Showing {{totalRecords}} results</div>
  </ng-template>
</div>


<div class="lightBox readstory block" *ngIf="unlockPopup">
  <div class="unlockStory">
    <div class="wid100 pad30">
      <h3>Unlock {{page_id === 'pages' ? 'Page' : 'Story'}}</h3>
      <p>{{lockedUser}} will be able to view this {{page_id === 'pages' ? 'page' : 'story'}} in read mode now.</p>
    </div>
    <div class="fr wid100 right padlr30 ptb15">
      <button type="button" name="cancel" (click)="cancelUnlock()" class="cancel gray mtb15 ml10">Cancel</button>
      <button type="button" name="unlock" (click)="unlockStory()" class="add blue mtb15 ml10 mr30">Unlock</button>
    </div>
  </div>
</div>
<ng-container *ngIf="openWirePreview && wirePreviewStory && wirePreviewStory !== null">
  <div class="lightBox wirePreview" style="display:block;">
    <div class="headerLight">
      <div class="close fl spImg" (click)="closePreview()"></div>
      <div class="rightBlock" *ngIf="page_id !== 'pulse_wires'">
        <ul>
         <!-- <li  *ngIf="type2 || type3">
            <button type="button" name="pickedtimes" class="createCard">Translate Story</button>
            <div class="pickstorywriter">
              <ul>
                <ng-container *ngFor="let language of targetLaguages">
                  <li (click)="openStoryEdit(wirePreviewStory, language.id)">
                    <div class="writername">{{language.name}}</div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </li> -->
          <li>
            <button type="button" name="pickedtimes" class="createCard" (click)="updateCopyCounter(wirePreviewStory)">Copied
              for Publish</button>
            <span class="usercount spImg">{{wirePreviewStory.copyCounter}}</span>
          </li>
          <li>
            <button type="button" name="pickedstory" class="createStory" (click)="openStoryEdit(wirePreviewStory)">Pick
              as a Story</button>
            <span class="usercount spImg">{{wirePreviewStory.wirePublishedStories ?
              wirePreviewStory.wirePublishedStories.length : 0}}</span>
            <div class="pickstorywriter" *ngIf="wirePreviewStory.wirePublishedStories && wirePreviewStory.wirePublishedStories.length > 0">
              <ul>
                <ng-container *ngFor="let storyItem of wirePreviewStory.wirePublishedStories">
                  <li (click)="open_new(storyItem.id)">
                    <div class="writername">{{storyItem.metadata ? (storyItem.metadata.authors &&
                      storyItem.metadata.authors.length > 0 ?
                      storyItem.metadata.authors[0] : (storyItem.title ? storyItem.title : '-')) : '-'}}</div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </li>
        </ul>
      </div>

    </div>
    <div class="lightContent" *ngIf="wirePreviewStory && wirePreviewStory !== null" [ngClass]="{'compare lft': compareStory}">
      <h2>{{wirePreviewStory.headline}}</h2>
      <h4>{{wirePreviewStory.story[0].summary}}</h4>
      <div class="update">
        <span class="agencyName">{{wirePreviewStory.agency}}</span>
        <ng-container *ngIf="wirePreviewStory.agency !== 'POPPER'">
          <span class="sectionName">{{wirePreviewStory.section}}</span>
        </ng-container>
        <ng-container *ngIf="wirePreviewStory.agency === 'POPPER'">
          <span class="sectionName">{{
            (wirePreviewStory.story[0] && wirePreviewStory.story[0]['metadata'] && wirePreviewStory.story[0]['metadata']['section'])
            ? wirePreviewStory.story[0]['metadata']['section'] : ''}}</span>
        </ng-container>
        <ng-container *ngIf="page_id === 'pulse_wires'; then pulseDateTemplate else datetemplate"></ng-container>
        <ng-template #datetemplate>
          <span class="receivedDate">{{wirePreviewStory.timestamp ? getNewTypeDate(wirePreviewStory.timestamp) : ''}}</span>
        </ng-template>
        <ng-template #pulseDateTemplate>
          <span class="receivedDate">{{wirePreviewStory.firstPublishedTimestamp ? getNewTypeDate(wirePreviewStory.firstPublishedTimestamp) : ''}}</span>
        </ng-template>

        <span class="bylines" *ngIf="wirePreviewStory && wirePreviewStory.story && (wirePreviewStory.story.length > 0) && (wirePreviewStory.story[0].author) && (wirePreviewStory.story[0].author) !== null">
          {{wirePreviewStory.story[0].author}}
        </span>
      </div>
      <ng-container *ngIf="wirePreviewStory && wirePreviewStory.story[0].images && wirePreviewStory.story[0].images.length > 0">
        <div id="pdfImage" class="wirecontentimg" *ngIf="wirePreviewStory.story[0].images[0].includes('pdf');else img">
          <ng2-pdfjs-viewer [pdfSrc]="wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].images[0]" (onDocumentLoad)="pdfDocumentLoaded($event)" [zoom]="auto" [print]="false" [find]="false" [download]="false" [fullScreen]="true" [openFile]="false">
          </ng2-pdfjs-viewer>
        </div>
        <ng-template  #img>
          <div id="pdfImage1" class="wirecontentimg">
              <img [src]="wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].images[0]">
          </div>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="wirePreviewStory.agency === 'POPPER'">
        <div id="pdfImage3" class="wirecontentimg" *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
        && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['images']
        && wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9'])">
          <img [src]="wirePreviewStory.story[0]['leadMedia']['image']['images']['16X9']">
       </div>
      <div class="captionLabel" *ngIf="(wirePreviewStory.story[0] && wirePreviewStory.story[0]['leadMedia']
       && wirePreviewStory.story[0]['leadMedia']['image'] && wirePreviewStory.story[0]['leadMedia']['image']['caption'])">
        <label>Caption: {{wirePreviewStory.story[0]['leadMedia']['image']['caption']}}</label>
      </div>
      </ng-container>
      <ng-container *ngIf="wirePreviewStory && wirePreviewStory.story[0].listImages && wirePreviewStory.story[0].listImages.length > 0">
        <div id="pdfImage2" class="wirecontentimg" *ngIf="wirePreviewStory.story[0].listImages[0].src.includes('pdf');else previewImg">
          <ng2-pdfjs-viewer [pdfSrc]="wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].listImages[0].src" (onDocumentLoad)="pdfDocumentLoaded($event)" [print]="false" [find]="false" [download]="false" [fullScreen]="true" [openFile]="false">
          </ng2-pdfjs-viewer>
          <div class="captionLabel">
            <label [innerHTML]="'Caption: ' + wirePreviewStory.story[0].listImages[0].caption"></label>
            </div>
        </div>
        <ng-template #previewImg>
         <div id="pdfImage3" class="wirecontentimg">
            <img [src]="wireImageDisplayUrl + wirePreviewStory.location + '/' + wirePreviewStory.story[0].listImages[0].src"
          [title]="wirePreviewStory.story[0].listImages[0].caption">
         </div>
        <div class="captionLabel">
          <label [innerHTML]="'Caption: ' + wirePreviewStory.story[0].listImages[0].caption"></label>
        </div>
        </ng-template>
      </ng-container>
      <ng-container *ngIf="page_id === 'pulse_wires'; then pulseTemplate else template"></ng-container>
      <ng-template #template>
        <div class="feedcontent" [innerHTML]="wirePreviewStory.story[0].content"></div>
      </ng-template>
      <ng-template #pulseTemplate>
        <div class="feedcontent">
          <a [href]="'http://www.dereferer.org/?'+wirePreviewStory.story[0].content" target="_blank">{{wirePreviewStory.story[0].content}}</a>
        </div>
      </ng-template>
      <ng-container *ngIf="wirePreviewStory && wirePreviewStory.story[0].images && wirePreviewStory.story[0].images.length > 1">
        <ng-container *ngFor="let image of wirePreviewStory.story[0].images; let i = index">
          <ng-container *ngIf="i > 0">
            <div class="wirecontentimg">
              <img [src]="wireImageDisplayUrl + wirePreviewStory.location + '/' + image">
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="wirePreviewStory && wirePreviewStory.story[0].listImages && wirePreviewStory.story[0].listImages.length > 1">
        <ng-container *ngFor="let image of wirePreviewStory.story[0].listImages; let i = index">
          <ng-container *ngIf="i > 0">
            <div class="wirecontentimg">
              <img [src]="wireImageDisplayUrl + wirePreviewStory.location + '/' + image.src" [title]="image.caption">
              <div class="captionLabel">
                <label [innerHTML]="'Caption: ' + image.caption"></label>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div class="lightContent" *ngIf="translatedPreviewStory && translatedPreviewStory !== null && compareStory" [ngClass]="{'compare rgt': compareStory}">
        <h2>{{translatedPreviewStory.headline}}</h2>
        <h4>{{translatedPreviewStory.story[0].summary}}</h4>
        <div class="update">
          <span class="agencyName">{{translatedPreviewStory.agency}}</span>
          <span class="sectionName">{{translatedPreviewStory.section}}</span>
          <span class="receivedDate">{{translatedPreviewStory.timestamp ? getNewTypeDate(translatedPreviewStory.timestamp) : ''}}</span>
          <span class="bylines" *ngIf="translatedPreviewStory && translatedPreviewStory.story && (translatedPreviewStory.story.length > 0) && (translatedPreviewStory.story[0].author) && (wirePreviewStory.story[0].author) !== null">
            {{translatedPreviewStory.story[0].author}}
          </span>
        </div>
        <ng-container *ngIf="translatedPreviewStory && translatedPreviewStory.story[0].images && translatedPreviewStory.story[0].images.length > 0">
          <div class="wirecontentimg">
            <img [src]="wireImageDisplayUrl + translatedPreviewStory.location + '/' + translatedPreviewStory.story[0].images[0]">
          </div>
        </ng-container>
        <ng-container *ngIf="translatedPreviewStory && translatedPreviewStory.story[0].listImages && translatedPreviewStory.story[0].listImages.length > 0">
          <div class="wirecontentimg">
            <img [src]="wireImageDisplayUrl + translatedPreviewStory.location + '/' + translatedPreviewStory.story[0].listImages[0].src"
              [title]="translatedPreviewStory.story[0].listImages[0].caption">
            <div class="captionLabel">
              <label [innerHTML]="'Caption: ' + translatedPreviewStory.story[0].listImages[0].caption"></label>
            </div>
          </div>
        </ng-container>
        <div class="feedcontent" [innerHTML]='translatedPreviewStory.story[0].content'></div>
        <ng-container *ngIf="translatedPreviewStory && translatedPreviewStory.story[0].images && translatedPreviewStory.story[0].images.length > 1">
          <ng-container *ngFor="let image of translatedPreviewStory.story[0].images; let i = index">
            <ng-container *ngIf="i > 0">
              <div class="wirecontentimg">
                <img [src]="wireImageDisplayUrl + translatedPreviewStory.location + '/' + image">
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="translatedPreviewStory && translatedPreviewStory.story[0].listImages && translatedPreviewStory.story[0].listImages.length > 1">
          <ng-container *ngFor="let image of translatedPreviewStory.story[0].listImages; let i = index">
            <ng-container *ngIf="i > 0">
              <div class="wirecontentimg">
                <img [src]="wireImageDisplayUrl + translatedPreviewStory.location + '/' + image.src" [title]="image.caption">
                <div class="captionLabel">
                  <label [innerHTML]="'Caption: ' + image.caption"></label>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
  </div>
</ng-container>


<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <!-- <h3>TRANSLATING...</h3> -->
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>

